import {TypeUUID, TypeDateIso} from '@pendwa/graphql/types/graphql.js'
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  TypeCrosswordClues: { input: any; output: any; }
  TypeCrosswordSolutionPlayerActions: { input: any; output: any; }
  TypeCrosswordSolutionPlayerValues: { input: any; output: any; }
  TypeCrosswordSolutionPlayerValuesMetadata: { input: any; output: any; }
  TypeCrosswordValues: { input: any; output: any; }
  TypeDateIso: { input: TypeDateIso; output: TypeDateIso; }
  TypeUUID: { input: TypeUUID; output: TypeUUID; }
};

export enum EnumAuthCodeDeviceType {
  AppleTv = 'appleTv'
}

export enum EnumConsumeCreditsActionType {
  PurchaseEpisode = 'purchase_episode',
  PurchaseMovie = 'purchase_movie',
  PurchaseSeason = 'purchase_season',
  PurchaseTv = 'purchase_tv',
  RentEpisode = 'rent_episode',
  RentMovie = 'rent_movie',
  RentSeason = 'rent_season',
  RentTv = 'rent_tv'
}

export enum EnumCreditVoucherActionType {
  Delete = 'delete'
}

export enum EnumCreditVoucherFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  CreditsAsc = 'creditsASC',
  CreditsDesc = 'creditsDESC',
  MaxUsesAsc = 'max_usesASC',
  MaxUsesDesc = 'max_usesDESC',
  MaxUsesUserAsc = 'max_uses_userASC',
  MaxUsesUserDesc = 'max_uses_userDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC',
  UsesAsc = 'usesASC',
  UsesDesc = 'usesDESC'
}

export enum EnumCreditVoucherPublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumCrosswordActionType {
  Ban = 'ban',
  Delete = 'delete',
  MakeToday = 'make_today',
  Publish = 'publish',
  StrictMode = 'strict_mode',
  Trash = 'trash',
  UnBan = 'un_ban',
  UnPublish = 'un_publish',
  UnStrictMode = 'un_strict_mode',
  UnTrash = 'un_trash'
}

export enum EnumCrosswordFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  FieldUuids = 'field_uuids',
  Search = 'search',
  TitleAsc = 'titleASC',
  TitleDesc = 'titleDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumCrosswordPublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumCrosswordSeriesActionType {
  Delete = 'delete',
  Publish = 'publish',
  UnPublish = 'un_publish'
}

export enum EnumCrosswordSeriesFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  EndTimeAsc = 'end_timeASC',
  EndTimeDesc = 'end_timeDESC',
  StartTimeAsc = 'start_timeASC',
  StartTimeDesc = 'start_timeDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumCrosswordSeriesPublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumCrosswordSolutionActionType {
  Delete = 'delete'
}

export enum EnumCrosswordSolutionFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumCrosswordSolutionPlayerActionType {
  CheckCell = 'check_cell',
  CheckEntry = 'check_entry',
  RevealCell = 'reveal_cell',
  RevealEntry = 'reveal_entry'
}

export enum EnumDateIntervalUnit {
  Last_3Months = 'last_3_months',
  Last_6Months = 'last_6_months',
  Last_7Days = 'last_7_days',
  Last_30Days = 'last_30_days',
  LastMonth = 'last_month',
  LastWeek = 'last_week',
  LastYear = 'last_year',
  Overall = 'overall',
  ThisMonth = 'this_month',
  ThisWeek = 'this_week',
  ThisYear = 'this_year',
  Today = 'today',
  Yesterday = 'yesterday'
}

export enum EnumDomainEnvGql {
  africacrosswords_com = 'africacrosswords_com',
  pendwa_app = 'pendwa_app',
  pendwa_org = 'pendwa_org',
  swiftcomment_com = 'swiftcomment_com'
}

export enum EnumEpisodeActionType {
  Ban = 'ban',
  Delete = 'delete',
  MakeNotPublic = 'make_not_public',
  MakePublic = 'make_public',
  Publish = 'publish',
  Trash = 'trash',
  UnBan = 'un_ban',
  UnPublish = 'un_publish',
  UnTrash = 'un_trash'
}

export enum EnumEpisodeFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  NumberAsc = 'numberASC',
  NumberDesc = 'numberDESC',
  PremierDateAsc = 'premier_dateASC',
  PremierDateDesc = 'premier_dateDESC',
  TitleAsc = 'titleASC',
  TitleDesc = 'titleDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumEpisodePublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumGenreActionType {
  Delete = 'delete'
}

export enum EnumGenreFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  NameAsc = 'nameASC',
  NameDesc = 'nameDESC',
  Search = 'search',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumGenrePublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumInstagramBusinessPermission {
  InstagramBusinessBasic = 'instagram_business_basic',
  InstagramBusinessManageComments = 'instagram_business_manage_comments',
  InstagramBusinessManageMessages = 'instagram_business_manage_messages'
}

export enum EnumLanguageActionType {
  Delete = 'delete'
}

export enum EnumLanguageFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  NameAsc = 'nameASC',
  NameDesc = 'nameDESC',
  Search = 'search',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumLanguagePublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumLoginAppleAgent {
  Ios = 'ios',
  Web = 'web'
}

export enum EnumMovieActionType {
  Ban = 'ban',
  Delete = 'delete',
  MakeNotPublic = 'make_not_public',
  MakePublic = 'make_public',
  Publish = 'publish',
  Trash = 'trash',
  UnBan = 'un_ban',
  UnPublish = 'un_publish',
  UnTrash = 'un_trash'
}

export enum EnumMovieFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  PremierDateAsc = 'premier_dateASC',
  PremierDateDesc = 'premier_dateDESC',
  TitleAsc = 'titleASC',
  TitleDesc = 'titleDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumMoviePublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumMpaaActionType {
  Delete = 'delete'
}

export enum EnumMpaaFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  NameAsc = 'nameASC',
  NameDesc = 'nameDESC',
  Search = 'search',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumMpaaPublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumPersonActionType {
  Delete = 'delete'
}

export enum EnumPersonFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  NameAsc = 'nameASC',
  NameDesc = 'nameDESC',
  Search = 'search',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumPersonPublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumProfileActionType {
  Delete = 'delete'
}

export enum EnumProfileFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  NameAsc = 'nameASC',
  NameDesc = 'nameDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumProfilePublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumProfileSavedActionType {
  Add = 'add',
  Archive = 'archive'
}

export enum EnumProfileSavedFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumProfileVoteActionType {
  ThumbsDown = 'thumbs_down',
  ThumbsDownRemove = 'thumbs_down_remove',
  ThumbsUp = 'thumbs_up',
  ThumbsUpRemove = 'thumbs_up_remove'
}

export enum EnumProfileVoteFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumProfileVoteVote {
  ThumbsDown = 'thumbs_down',
  ThumbsUp = 'thumbs_up'
}

export enum EnumProfileWatchHistoryFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumRegionActionType {
  Delete = 'delete'
}

export enum EnumRegionFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  NameAsc = 'nameASC',
  NameDesc = 'nameDESC',
  Search = 'search',
  SlugAsc = 'slugASC',
  SlugDesc = 'slugDESC'
}

export enum EnumRegionPublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumSCBusinessActionType {
  Delete = 'delete'
}

export enum EnumSCBusinessWorkflowActionType {
  Delete = 'delete'
}

export enum EnumSCPlatformGql {
  Instagram = 'instagram'
}

export enum EnumSCPostWorkflowActionType {
  Delete = 'delete'
}

export enum EnumSavedActionType {
  Add = 'add',
  Archive = 'archive'
}

export enum EnumSavedFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumSeasonActionType {
  Ban = 'ban',
  Delete = 'delete',
  MakeNotPublic = 'make_not_public',
  MakePublic = 'make_public',
  Publish = 'publish',
  Trash = 'trash',
  UnBan = 'un_ban',
  UnPublish = 'un_publish',
  UnTrash = 'un_trash'
}

export enum EnumSeasonFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  NumberAsc = 'numberASC',
  NumberDesc = 'numberDESC',
  PremierDateAsc = 'premier_dateASC',
  PremierDateDesc = 'premier_dateDESC',
  TitleAsc = 'titleASC',
  TitleDesc = 'titleDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumSeasonPublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumSettingFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC'
}

export enum EnumSettingPublishActionType {
  Edit = 'edit'
}

export enum EnumShowFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  FieldUuids = 'field_uuids',
  PremierDateAsc = 'premier_dateASC',
  PremierDateDesc = 'premier_dateDESC',
  TitleAsc = 'titleASC',
  TitleDesc = 'titleDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumShowSeriesActionType {
  Delete = 'delete',
  Publish = 'publish',
  UnPublish = 'un_publish'
}

export enum EnumShowSeriesFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  EndTimeAsc = 'end_timeASC',
  EndTimeDesc = 'end_timeDESC',
  StartTimeAsc = 'start_timeASC',
  StartTimeDesc = 'start_timeDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumShowSeriesPublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumTagActionType {
  Delete = 'delete'
}

export enum EnumTagFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  NameAsc = 'nameASC',
  NameDesc = 'nameDESC',
  Search = 'search',
  SlugAsc = 'slugASC',
  SlugDesc = 'slugDESC'
}

export enum EnumTagPublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumTvActionType {
  Ban = 'ban',
  Delete = 'delete',
  MakeNotPublic = 'make_not_public',
  MakePublic = 'make_public',
  Publish = 'publish',
  Trash = 'trash',
  UnBan = 'un_ban',
  UnPublish = 'un_publish',
  UnTrash = 'un_trash'
}

export enum EnumTvFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  PremierDateAsc = 'premier_dateASC',
  PremierDateDesc = 'premier_dateDESC',
  TitleAsc = 'titleASC',
  TitleDesc = 'titleDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumTvPublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumUploadActionType {
  Delete = 'delete'
}

export enum EnumUploadFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  NameAsc = 'nameASC',
  NameDesc = 'nameDESC',
  SequenceAsc = 'sequenceASC',
  SequenceDesc = 'sequenceDESC'
}

export enum EnumUploadPublishActionType {
  Edit = 'edit'
}

export enum EnumUserActionType {
  Approve = 'approve',
  Ban = 'ban',
  Delete = 'delete',
  UnBan = 'un_ban'
}

export enum EnumUserFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  NameAsc = 'nameASC',
  NameDesc = 'nameDESC',
  Search = 'search',
  UserNameAsc = 'user_nameASC',
  UserNameDesc = 'user_nameDESC'
}

export enum EnumUserPublishActionType {
  Edit = 'edit'
}

export enum EnumUserPublishSudoActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumUserShowPurchaseActionType {
  Delete = 'delete'
}

export enum EnumUserShowPurchaseFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumUserShowPurchasePublishActionType {
  Edit = 'edit',
  New = 'new'
}

export enum EnumUserShowRentActionType {
  Delete = 'delete'
}

export enum EnumUserShowRentFindParamsSort {
  CreatedAtAsc = 'created_atASC',
  CreatedAtDesc = 'created_atDESC',
  UpdatedAtAsc = 'updated_atASC',
  UpdatedAtDesc = 'updated_atDESC'
}

export enum EnumUserShowRentPublishActionType {
  Edit = 'edit',
  New = 'new'
}

export type InputAccountConfirmEmailBody = {
  token: Scalars['String']['input'];
};

export type InputAccountCreateBody = {
  confirm_password: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type InputAccountLoginAppleBody = {
  agent: EnumLoginAppleAgent;
  id_token: Scalars['String']['input'];
};

export type InputAccountLoginBody = {
  password: Scalars['String']['input'];
  user_name: Scalars['String']['input'];
};

export type InputAccountLoginCodeBody = {
  code: Scalars['Int']['input'];
};

export type InputAccountLoginFacebookBody = {
  access_token: Scalars['String']['input'];
};

export type InputAccountLoginGoogleBody = {
  id_token: Scalars['String']['input'];
};

export type InputAccountResetPasswordBody = {
  confirm_password: Scalars['String']['input'];
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type InputApplyCreditVoucherBody = {
  code: Scalars['String']['input'];
};

export type InputAuthCodeBody = {
  code: Scalars['String']['input'];
  device_type: EnumAuthCodeDeviceType;
};

export type InputConnectInstagramBusinessBody = {
  code: Scalars['String']['input'];
  redirect_uri: Scalars['String']['input'];
  replace_existing_connections: Scalars['Boolean']['input'];
  required_permissions: Array<EnumInstagramBusinessPermission>;
};

export type InputConsumeCreditsActionBody = {
  action: EnumConsumeCreditsActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCreateAuthCodeBody = {
  device_type: EnumAuthCodeDeviceType;
};

export type InputCreditVoucherActionBody = {
  action: EnumCreditVoucherActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCreditVoucherBody = {
  credit_voucher_find_params: InputCreditVoucherFindParams;
};

export type InputCreditVoucherFindParams = {
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
  credits_max?: InputMaybe<Scalars['Float']['input']>;
  credits_min?: InputMaybe<Scalars['Float']['input']>;
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  end_time_max?: InputMaybe<InputDate>;
  end_time_min?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  has_ended?: InputMaybe<Scalars['Boolean']['input']>;
  has_started?: InputMaybe<Scalars['Boolean']['input']>;
  max_uses_max?: InputMaybe<Scalars['Int']['input']>;
  max_uses_min?: InputMaybe<Scalars['Int']['input']>;
  max_uses_user_max?: InputMaybe<Scalars['Int']['input']>;
  max_uses_user_min?: InputMaybe<Scalars['Int']['input']>;
  page: Scalars['Int']['input'];
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<EnumCreditVoucherFindParamsSort>>;
  start_time_max?: InputMaybe<InputDate>;
  start_time_min?: InputMaybe<InputDate>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uses_max?: InputMaybe<Scalars['Int']['input']>;
  uses_min?: InputMaybe<Scalars['Int']['input']>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputCreditVoucherPublishBody = {
  action: EnumCreditVoucherPublishActionType;
  credit_voucher: InputCreditVoucherPublishFields;
};

export type InputCreditVoucherPublishFields = {
  code?: InputMaybe<Scalars['String']['input']>;
  credits?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<InputDate>;
  max_uses?: InputMaybe<Scalars['Int']['input']>;
  max_uses_user?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<InputDate>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordActionBody = {
  action: EnumCrosswordActionType;
  created_at_to_now: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordBody = {
  crossword_find_params: InputCrosswordFindParams;
};

export type InputCrosswordCell = {
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type InputCrosswordData = {
  clues: Scalars['TypeCrosswordClues']['input'];
  dimensions: InputCrosswordDimensions;
  entries: InputCrosswordEntries;
  values: Scalars['TypeCrosswordValues']['input'];
};

export type InputCrosswordDimensions = {
  height: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type InputCrosswordEntries = {
  across: Array<InputCrosswordEntry>;
  down: Array<InputCrosswordEntry>;
};

export type InputCrosswordEntry = {
  direction: Scalars['String']['input'];
  end: InputCrosswordCell;
  human_index: Scalars['Int']['input'];
  id: Scalars['String']['input'];
  length: Scalars['Int']['input'];
  start: InputCrosswordCell;
  value: Scalars['String']['input'];
};

export type InputCrosswordFindParams = {
  category_types?: InputMaybe<Array<Scalars['String']['input']>>;
  crossword_series_find_params?: InputMaybe<InputCrosswordSeriesFindParams>;
  crossword_solution_find_params?: InputMaybe<InputCrosswordSolutionFindParams>;
  date_end?: InputMaybe<InputDate>;
  date_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_start?: InputMaybe<InputDate>;
  excluded_numbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_banned?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  is_today?: InputMaybe<Scalars['Boolean']['input']>;
  is_trashed?: InputMaybe<Scalars['Boolean']['input']>;
  last_n_days?: InputMaybe<Scalars['Int']['input']>;
  numbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  person_find_params?: InputMaybe<InputPersonFindParams>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  region_find_params?: InputMaybe<InputRegionFindParams>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  show_ads?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Array<EnumCrosswordFindParamsSort>>;
  strict_mode?: InputMaybe<Scalars['Boolean']['input']>;
  tag_find_params?: InputMaybe<InputTagFindParams>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputCrosswordPublishBody = {
  action: EnumCrosswordPublishActionType;
  crossword: InputCrosswordPublishFields;
};

export type InputCrosswordPublishCategory = {
  type: Scalars['String']['input'];
};

export type InputCrosswordPublishFields = {
  category?: InputMaybe<Array<InputCrosswordPublishCategory>>;
  data?: InputMaybe<InputCrosswordData>;
  image?: InputMaybe<Array<InputCrosswordPublishImage>>;
  long_description?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Array<InputCrosswordPublishRegion>>;
  setter?: InputMaybe<Array<InputCrosswordPublishPerson>>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  show_ads?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<Array<InputCrosswordPublishTag>>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordPublishImage = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordPublishPerson = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordPublishRegion = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordPublishTag = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordSeriesActionBody = {
  action: EnumCrosswordSeriesActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordSeriesBody = {
  crossword_series_find_params: InputCrosswordSeriesFindParams;
};

export type InputCrosswordSeriesCrosswordBody = {
  page: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type InputCrosswordSeriesFindParams = {
  crossword_find_params?: InputMaybe<InputCrosswordFindParams>;
  date_end?: InputMaybe<InputDate>;
  date_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_start?: InputMaybe<InputDate>;
  has_ended?: InputMaybe<Scalars['Boolean']['input']>;
  has_started?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  max_end_time?: InputMaybe<InputDate>;
  max_start_time?: InputMaybe<InputDate>;
  min_end_time?: InputMaybe<InputDate>;
  min_start_time?: InputMaybe<InputDate>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Array<EnumCrosswordSeriesFindParamsSort>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputCrosswordSeriesPublishBody = {
  action: EnumCrosswordSeriesPublishActionType;
  crossword_series: InputCrosswordSeriesPublishFields;
};

export type InputCrosswordSeriesPublishFields = {
  crossword_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  description_rich?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<InputDate>;
  image?: InputMaybe<Array<InputCrosswordSeriesPublishImage>>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<InputDate>;
  type?: InputMaybe<Scalars['String']['input']>;
  user_uuid?: InputMaybe<Scalars['TypeUUID']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordSeriesPublishImage = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordSolutionActionBody = {
  action: EnumCrosswordSolutionActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordSolutionBody = {
  crossword_solution_find_params: InputCrosswordSolutionFindParams;
  me?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputCrosswordSolutionFindParams = {
  crossword_find_params?: InputMaybe<InputCrosswordFindParams>;
  date_completed_end?: InputMaybe<InputDate>;
  date_completed_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_completed_start?: InputMaybe<InputDate>;
  date_end?: InputMaybe<InputDate>;
  date_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_start?: InputMaybe<InputDate>;
  has_revealed_all?: InputMaybe<Scalars['Boolean']['input']>;
  has_revealed_any?: InputMaybe<Scalars['Boolean']['input']>;
  is_complete?: InputMaybe<Scalars['Boolean']['input']>;
  last_completed_n_days?: InputMaybe<Scalars['Int']['input']>;
  last_n_days?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  score_end?: InputMaybe<Scalars['Int']['input']>;
  score_start?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<EnumCrosswordSolutionFindParamsSort>>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputCrosswordSolutionPlayerActionBody = {
  action: EnumCrosswordSolutionPlayerActionType;
  location: Scalars['String']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputCrosswordSolutionPublishBody = {
  crossword_solution: InputCrosswordSolutionPublishFields;
};

export type InputCrosswordSolutionPublishDataFields = {
  player_values: Scalars['TypeCrosswordSolutionPlayerValues']['input'];
  player_values_metadata?: InputMaybe<Scalars['TypeCrosswordSolutionPlayerValuesMetadata']['input']>;
};

export type InputCrosswordSolutionPublishFields = {
  crossword_uuid: Scalars['TypeUUID']['input'];
  data: InputCrosswordSolutionPublishDataFields;
  has_revealed_all?: InputMaybe<Scalars['Boolean']['input']>;
  has_revealed_any?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDate = {
  iso: Scalars['TypeDateIso']['input'];
};

export type InputEpisodeActionBody = {
  action: EnumEpisodeActionType;
  created_at_to_now: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputEpisodeBody = {
  episode_find_params: InputEpisodeFindParams;
};

export type InputEpisodeFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_start?: InputMaybe<InputDate>;
  excluded_numbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  free_for_subscriber?: InputMaybe<Scalars['Boolean']['input']>;
  has_premiered?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_banned?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  is_trashed?: InputMaybe<Scalars['Boolean']['input']>;
  last_n_days?: InputMaybe<Scalars['Int']['input']>;
  max_purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  max_purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  max_rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  max_rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  min_rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  min_rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  numbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  person_find_params?: InputMaybe<InputPersonFindParams>;
  premier_date_end?: InputMaybe<InputDate>;
  premier_date_start?: InputMaybe<InputDate>;
  purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rentable?: InputMaybe<Scalars['Boolean']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  season_find_params?: InputMaybe<InputSeasonFindParams>;
  show_ads?: InputMaybe<Scalars['Boolean']['input']>;
  show_series_find_params?: InputMaybe<InputShowSeriesFindParams>;
  sort?: InputMaybe<Array<EnumEpisodeFindParamsSort>>;
  tv_find_params?: InputMaybe<InputTvFindParams>;
  upload_find_params?: InputMaybe<InputUploadFindParams>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  watchable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputEpisodePublishBody = {
  action: EnumEpisodePublishActionType;
  episode: InputEpisodePublishFields;
};

export type InputEpisodePublishFields = {
  admin_title?: InputMaybe<Scalars['String']['input']>;
  free_for_subscriber?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Array<InputEpisodePublishImage>>;
  long_description?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<Array<InputEpisodePublishPerson>>;
  premier_date?: InputMaybe<InputDate>;
  purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  rentable?: InputMaybe<Scalars['Boolean']['input']>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  show_ads?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trailer?: InputMaybe<Array<InputEpisodePublishTrailer>>;
  uuid: Scalars['TypeUUID']['input'];
  video?: InputMaybe<Array<InputEpisodePublishVideo>>;
};

export type InputEpisodePublishImage = {
  is_thumbnail: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputEpisodePublishPerson = {
  is_actor: Scalars['Boolean']['input'];
  is_creator: Scalars['Boolean']['input'];
  is_director: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputEpisodePublishTrailer = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputEpisodePublishVideo = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputGenreActionBody = {
  action: EnumGenreActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputGenreBody = {
  genre_find_params: InputGenreFindParams;
};

export type InputGenreFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  movie_find_params?: InputMaybe<InputMovieFindParams>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<EnumGenreFindParamsSort>>;
  tv_find_params?: InputMaybe<InputTvFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputGenrePublishBody = {
  action: EnumGenrePublishActionType;
  genre: InputGenrePublishFields;
};

export type InputGenrePublishFields = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputLanguageActionBody = {
  action: EnumLanguageActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputLanguageBody = {
  language_find_params: InputLanguageFindParams;
};

export type InputLanguageFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<EnumLanguageFindParamsSort>>;
  upload_find_params?: InputMaybe<InputUploadFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputLanguagePublishBody = {
  action: EnumLanguagePublishActionType;
  language: InputLanguagePublishFields;
};

export type InputLanguagePublishFields = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputLoginAuthCodeBody = {
  code: Scalars['String']['input'];
};

export type InputMovieActionBody = {
  action: EnumMovieActionType;
  created_at_to_now: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputMovieBody = {
  movie_find_params: InputMovieFindParams;
};

export type InputMovieFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_start?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  free_for_subscriber?: InputMaybe<Scalars['Boolean']['input']>;
  genre_find_params?: InputMaybe<InputGenreFindParams>;
  has_premiered?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_banned?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  is_trashed?: InputMaybe<Scalars['Boolean']['input']>;
  last_n_days?: InputMaybe<Scalars['Int']['input']>;
  max_purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  max_purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  max_rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  max_rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  min_rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  min_rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  mpaa_find_params?: InputMaybe<InputMpaaFindParams>;
  owner_user_find_params?: InputMaybe<InputUserFindParams>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  person_find_params?: InputMaybe<InputPersonFindParams>;
  premier_date_end?: InputMaybe<InputDate>;
  premier_date_start?: InputMaybe<InputDate>;
  purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  region_find_params?: InputMaybe<InputRegionFindParams>;
  rentable?: InputMaybe<Scalars['Boolean']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  show_ads?: InputMaybe<Scalars['Boolean']['input']>;
  show_series_find_params?: InputMaybe<InputShowSeriesFindParams>;
  sort?: InputMaybe<Array<EnumMovieFindParamsSort>>;
  tag_find_params?: InputMaybe<InputTagFindParams>;
  upload_find_params?: InputMaybe<InputUploadFindParams>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  watchable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputMoviePublishBody = {
  action: EnumMoviePublishActionType;
  movie: InputMoviePublishFields;
};

export type InputMoviePublishFields = {
  admin_title?: InputMaybe<Scalars['String']['input']>;
  free_for_subscriber?: InputMaybe<Scalars['Boolean']['input']>;
  genre?: InputMaybe<Array<InputMoviePublishGenre>>;
  image?: InputMaybe<Array<InputMoviePublishImage>>;
  long_description?: InputMaybe<Scalars['String']['input']>;
  mpaa?: InputMaybe<Array<InputMoviePublishMpaa>>;
  owner_user_uuid?: InputMaybe<Scalars['TypeUUID']['input']>;
  person?: InputMaybe<Array<InputMoviePublishPerson>>;
  premier_date?: InputMaybe<InputDate>;
  purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_commission_percent?: InputMaybe<Scalars['Int']['input']>;
  purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Array<InputMoviePublishRegion>>;
  rent_commission_percent?: InputMaybe<Scalars['Int']['input']>;
  rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  rentable?: InputMaybe<Scalars['Boolean']['input']>;
  search_token?: InputMaybe<Scalars['String']['input']>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  show_ads?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<Array<InputMoviePublishTag>>;
  title?: InputMaybe<Scalars['String']['input']>;
  trailer?: InputMaybe<Array<InputMoviePublishTrailer>>;
  uuid: Scalars['TypeUUID']['input'];
  video?: InputMaybe<Array<InputMoviePublishVideo>>;
};

export type InputMoviePublishGenre = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputMoviePublishImage = {
  is_thumbnail: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputMoviePublishMpaa = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputMoviePublishPerson = {
  is_actor: Scalars['Boolean']['input'];
  is_creator: Scalars['Boolean']['input'];
  is_director: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputMoviePublishRegion = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputMoviePublishTag = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputMoviePublishTrailer = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputMoviePublishVideo = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputMpaaActionBody = {
  action: EnumMpaaActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputMpaaBody = {
  mpaa_find_params: InputMpaaFindParams;
};

export type InputMpaaFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  movie_find_params?: InputMaybe<InputMovieFindParams>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<EnumMpaaFindParamsSort>>;
  tv_find_params?: InputMaybe<InputTvFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputMpaaPublishBody = {
  action: EnumMpaaPublishActionType;
  mpaa: InputMpaaPublishFields;
};

export type InputMpaaPublishFields = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputPageCrosswordCategoryParams = {
  type: Scalars['String']['input'];
};

export type InputPageCrosswordCrosswordParams = {
  number: Scalars['Int']['input'];
};

export type InputPageCrosswordSearchParams = {
  text: Scalars['String']['input'];
};

export type InputPageCrosswordSeriesParams = {
  slug: Scalars['String']['input'];
};

export type InputPageEntryPersonParams = {
  user_name: Scalars['String']['input'];
};

export type InputPageShowMovieParams = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputPageShowPlayerParams = {
  fresh: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputPageShowSearchParams = {
  text: Scalars['String']['input'];
};

export type InputPageShowTvParams = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputPersonActionBody = {
  action: EnumPersonActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputPersonBody = {
  person_find_params: InputPersonFindParams;
};

export type InputPersonFindParams = {
  crossword_find_params?: InputMaybe<InputCrosswordFindParams>;
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  episode_actor_find_params?: InputMaybe<InputEpisodeFindParams>;
  episode_creator_find_params?: InputMaybe<InputEpisodeFindParams>;
  episode_director_find_params?: InputMaybe<InputEpisodeFindParams>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  facebook_user_names?: InputMaybe<Array<Scalars['String']['input']>>;
  movie_actor_find_params?: InputMaybe<InputMovieFindParams>;
  movie_creator_find_params?: InputMaybe<InputMovieFindParams>;
  movie_director_find_params?: InputMaybe<InputMovieFindParams>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  season_actor_find_params?: InputMaybe<InputSeasonFindParams>;
  season_creator_find_params?: InputMaybe<InputSeasonFindParams>;
  season_director_find_params?: InputMaybe<InputSeasonFindParams>;
  sort?: InputMaybe<Array<EnumPersonFindParamsSort>>;
  tv_actor_find_params?: InputMaybe<InputTvFindParams>;
  tv_creator_find_params?: InputMaybe<InputTvFindParams>;
  tv_director_find_params?: InputMaybe<InputTvFindParams>;
  twitter_user_names?: InputMaybe<Array<Scalars['String']['input']>>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputPersonPublishBody = {
  action: EnumPersonPublishActionType;
  person: InputPersonPublishFields;
};

export type InputPersonPublishFields = {
  biography?: InputMaybe<Scalars['String']['input']>;
  birth_date?: InputMaybe<InputDate>;
  facebook_user_name?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Array<InputPersonPublishImage>>;
  name?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  twitter_user_name?: InputMaybe<Scalars['String']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputPersonPublishImage = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputProfileActionBody = {
  action: EnumProfileActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputProfileBody = {
  profile_find_params: InputProfileFindParams;
};

export type InputProfileFindParams = {
  autoplay_next_episode?: InputMaybe<Scalars['Boolean']['input']>;
  autoplay_preview?: InputMaybe<Scalars['Boolean']['input']>;
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<EnumProfileFindParamsSort>>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputProfileLoginBody = {
  uuid: Scalars['String']['input'];
};

export type InputProfilePublishBody = {
  action: EnumProfilePublishActionType;
  profile: InputProfilePublishFields;
};

export type InputProfilePublishFields = {
  autoplay_next_episode?: InputMaybe<Scalars['Boolean']['input']>;
  autoplay_preview?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Array<InputProfilePublishImage>>;
  is_default?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  user_uuid: Scalars['TypeUUID']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputProfilePublishImage = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputProfileSavedActionBody = {
  action: EnumProfileSavedActionType;
  movie_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  tv_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputProfileSavedBody = {
  me_profile?: InputMaybe<Scalars['Boolean']['input']>;
  profile_saved_find_params: InputProfileSavedFindParams;
};

export type InputProfileSavedFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  movie_find_params?: InputMaybe<InputMovieFindParams>;
  page: Scalars['Int']['input'];
  profile_find_params?: InputMaybe<InputProfileFindParams>;
  quantity: Scalars['Int']['input'];
  sort?: InputMaybe<Array<EnumProfileSavedFindParamsSort>>;
  tv_find_params?: InputMaybe<InputTvFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputProfileVoteActionBody = {
  action: EnumProfileVoteActionType;
  movie_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  tv_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputProfileVoteBody = {
  me_profile?: InputMaybe<Scalars['Boolean']['input']>;
  profile_vote_find_params: InputProfileVoteFindParams;
};

export type InputProfileVoteFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  movie_find_params?: InputMaybe<InputMovieFindParams>;
  page: Scalars['Int']['input'];
  profile_find_params?: InputMaybe<InputProfileFindParams>;
  quantity: Scalars['Int']['input'];
  sort?: InputMaybe<Array<EnumProfileVoteFindParamsSort>>;
  tv_find_params?: InputMaybe<InputTvFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  vote?: InputMaybe<EnumProfileVoteVote>;
};

export type InputProfileWatchHistoryActionBody = {
  episode_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  movie_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  progress: Scalars['Float']['input'];
};

export type InputProfileWatchHistoryBody = {
  me_profile?: InputMaybe<Scalars['Boolean']['input']>;
  profile_watch_history_find_params: InputProfileWatchHistoryFindParams;
};

export type InputProfileWatchHistoryFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  date_updated_end?: InputMaybe<InputDate>;
  date_updated_start?: InputMaybe<InputDate>;
  episode_find_params?: InputMaybe<InputEpisodeFindParams>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  movie_find_params?: InputMaybe<InputMovieFindParams>;
  page: Scalars['Int']['input'];
  profile_find_params?: InputMaybe<InputProfileFindParams>;
  progress_end?: InputMaybe<Scalars['Int']['input']>;
  progress_start?: InputMaybe<Scalars['Int']['input']>;
  quantity: Scalars['Int']['input'];
  sort?: InputMaybe<Array<EnumProfileWatchHistoryFindParamsSort>>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputRegionActionBody = {
  action: EnumRegionActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputRegionBody = {
  region_find_params: InputRegionFindParams;
};

export type InputRegionFindParams = {
  crossword_find_params?: InputMaybe<InputCrosswordFindParams>;
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  movie_find_params?: InputMaybe<InputMovieFindParams>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Array<EnumRegionFindParamsSort>>;
  tv_find_params?: InputMaybe<InputTvFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputRegionPublishBody = {
  action: EnumRegionPublishActionType;
  region: InputRegionPublishFields;
};

export type InputRegionPublishFields = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputSCBusinessActionBody = {
  action: EnumSCBusinessActionType;
  id: Scalars['String']['input'];
};

export type InputSCBusinessWorkflowActionBody = {
  action: EnumSCBusinessWorkflowActionType;
  business_id: Scalars['String']['input'];
};

export type InputSCBusinessWorkflowPublishBody = {
  business_id: Scalars['String']['input'];
  instructions_text?: InputMaybe<Scalars['String']['input']>;
  reply_as_message?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputSCCommentPublishBody = {
  business_id: Scalars['String']['input'];
  comment_id: Scalars['String']['input'];
  commenter_id: Scalars['String']['input'];
  reply_as_message: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
};

export type InputSCPostWorkflowActionBody = {
  action: EnumSCPostWorkflowActionType;
  post_id: Scalars['String']['input'];
};

export type InputSCPostWorkflowPublishBody = {
  business_id: Scalars['String']['input'];
  instructions_text?: InputMaybe<Scalars['String']['input']>;
  post_id: Scalars['String']['input'];
  reply_as_message?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputSavedActionBody = {
  action: EnumSavedActionType;
  crossword_pathnames?: InputMaybe<Array<Scalars['String']['input']>>;
  crossword_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputSavedBody = {
  me?: InputMaybe<Scalars['Boolean']['input']>;
  saved_find_params: InputSavedFindParams;
};

export type InputSavedFindParams = {
  crossword_find_params?: InputMaybe<InputCrosswordFindParams>;
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  sort?: InputMaybe<Array<EnumSavedFindParamsSort>>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputSeasonActionBody = {
  action: EnumSeasonActionType;
  created_at_to_now: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputSeasonBody = {
  season_find_params: InputSeasonFindParams;
};

export type InputSeasonFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_start?: InputMaybe<InputDate>;
  episode_find_params?: InputMaybe<InputEpisodeFindParams>;
  excluded_numbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  free_for_subscriber?: InputMaybe<Scalars['Boolean']['input']>;
  has_premiered?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_banned?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  is_trashed?: InputMaybe<Scalars['Boolean']['input']>;
  last_n_days?: InputMaybe<Scalars['Int']['input']>;
  max_purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  max_purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  max_rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  max_rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  min_rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  min_rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  numbers?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  person_find_params?: InputMaybe<InputPersonFindParams>;
  premier_date_end?: InputMaybe<InputDate>;
  premier_date_start?: InputMaybe<InputDate>;
  purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  rentable?: InputMaybe<Scalars['Boolean']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  show_ads?: InputMaybe<Scalars['Boolean']['input']>;
  show_series_find_params?: InputMaybe<InputShowSeriesFindParams>;
  sort?: InputMaybe<Array<EnumSeasonFindParamsSort>>;
  tv_find_params?: InputMaybe<InputTvFindParams>;
  upload_find_params?: InputMaybe<InputUploadFindParams>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  watchable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputSeasonPublishBody = {
  action: EnumSeasonPublishActionType;
  season: InputSeasonPublishFields;
};

export type InputSeasonPublishEpisode = {
  number: Scalars['Int']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputSeasonPublishFields = {
  admin_title?: InputMaybe<Scalars['String']['input']>;
  episode?: InputMaybe<Array<InputSeasonPublishEpisode>>;
  free_for_subscriber?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Array<InputSeasonPublishImage>>;
  long_description?: InputMaybe<Scalars['String']['input']>;
  person?: InputMaybe<Array<InputSeasonPublishPerson>>;
  premier_date?: InputMaybe<InputDate>;
  purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  rentable?: InputMaybe<Scalars['Boolean']['input']>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  show_ads?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  trailer?: InputMaybe<Array<InputSeasonPublishTrailer>>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputSeasonPublishImage = {
  is_thumbnail: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputSeasonPublishPerson = {
  is_actor: Scalars['Boolean']['input'];
  is_creator: Scalars['Boolean']['input'];
  is_director: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputSeasonPublishTrailer = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputSeasonPublishUser = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputSendConfirmEmailLinkBody = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputSendLoginCodeBody = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export type InputSendPasswordResetLinkBody = {
  email: Scalars['String']['input'];
};

export type InputSettingBody = {
  setting_find_params: InputSettingFindParams;
};

export type InputSettingFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  page: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  sort?: InputMaybe<Array<EnumSettingFindParamsSort>>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputSettingPublishBody = {
  action: EnumSettingPublishActionType;
  setting: InputSettingPublishFields;
};

export type InputSettingPublishFields = {
  ads?: InputMaybe<Scalars['Boolean']['input']>;
  ads_adsense?: InputMaybe<Scalars['Boolean']['input']>;
  user_approved_by_default?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputShowBody = {
  show_find_params: InputShowFindParams;
};

export type InputShowFindParams = {
  episode_find_params?: InputMaybe<InputEpisodeFindParams>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  movie_find_params?: InputMaybe<InputMovieFindParams>;
  no_episode?: InputMaybe<Scalars['Boolean']['input']>;
  no_movie?: InputMaybe<Scalars['Boolean']['input']>;
  no_season?: InputMaybe<Scalars['Boolean']['input']>;
  no_show_series?: InputMaybe<Scalars['Boolean']['input']>;
  no_tv?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  season_find_params?: InputMaybe<InputSeasonFindParams>;
  show_series_find_params?: InputMaybe<InputShowSeriesFindParams>;
  sort?: InputMaybe<Array<EnumShowFindParamsSort>>;
  tv_find_params?: InputMaybe<InputTvFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputShowSeriesActionBody = {
  action: EnumShowSeriesActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputShowSeriesBody = {
  show_series_find_params: InputShowSeriesFindParams;
};

export type InputShowSeriesFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_start?: InputMaybe<InputDate>;
  has_ended?: InputMaybe<Scalars['Boolean']['input']>;
  has_started?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  max_end_time?: InputMaybe<InputDate>;
  max_items?: InputMaybe<Scalars['Int']['input']>;
  max_start_time?: InputMaybe<InputDate>;
  min_end_time?: InputMaybe<InputDate>;
  min_items?: InputMaybe<Scalars['Int']['input']>;
  min_start_time?: InputMaybe<InputDate>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Array<EnumShowSeriesFindParamsSort>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputShowSeriesPublishBody = {
  action: EnumShowSeriesPublishActionType;
  show_series: InputShowSeriesPublishFields;
};

export type InputShowSeriesPublishFields = {
  description?: InputMaybe<Scalars['String']['input']>;
  description_rich?: InputMaybe<Scalars['String']['input']>;
  end_time?: InputMaybe<InputDate>;
  image?: InputMaybe<Array<InputShowSeriesPublishImage>>;
  name?: InputMaybe<Scalars['String']['input']>;
  show_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<InputDate>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputShowSeriesPublishImage = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputSignedUrlForUpload = {
  content_type: Scalars['String']['input'];
  file_name: Scalars['String']['input'];
  is_public: Scalars['Boolean']['input'];
  uuid: Scalars['String']['input'];
};

export type InputTagActionBody = {
  action: EnumTagActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputTagBody = {
  tag_find_params: InputTagFindParams;
};

export type InputTagFindParams = {
  crossword_find_params?: InputMaybe<InputCrosswordFindParams>;
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  movie_find_params?: InputMaybe<InputMovieFindParams>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Array<EnumTagFindParamsSort>>;
  tv_find_params?: InputMaybe<InputTvFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputTagPublishBody = {
  action: EnumTagPublishActionType;
  tag: InputTagPublishFields;
};

export type InputTagPublishFields = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputTvActionBody = {
  action: EnumTvActionType;
  created_at_to_now: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputTvBody = {
  tv_find_params: InputTvFindParams;
};

export type InputTvFindParams = {
  date_end?: InputMaybe<InputDate>;
  date_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_start?: InputMaybe<InputDate>;
  episode_find_params?: InputMaybe<InputEpisodeFindParams>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  free_for_subscriber?: InputMaybe<Scalars['Boolean']['input']>;
  genre_find_params?: InputMaybe<InputGenreFindParams>;
  has_premiered?: InputMaybe<Scalars['Boolean']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_banned?: InputMaybe<Scalars['Boolean']['input']>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  is_trashed?: InputMaybe<Scalars['Boolean']['input']>;
  last_n_days?: InputMaybe<Scalars['Int']['input']>;
  max_purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  max_purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  max_rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  max_rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  min_purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  min_rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  min_rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  mpaa_find_params?: InputMaybe<InputMpaaFindParams>;
  owner_user_find_params?: InputMaybe<InputUserFindParams>;
  page?: InputMaybe<Scalars['Int']['input']>;
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  person_find_params?: InputMaybe<InputPersonFindParams>;
  premier_date_end?: InputMaybe<InputDate>;
  premier_date_start?: InputMaybe<InputDate>;
  purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  region_find_params?: InputMaybe<InputRegionFindParams>;
  rentable?: InputMaybe<Scalars['Boolean']['input']>;
  search_string?: InputMaybe<Scalars['String']['input']>;
  season_find_params?: InputMaybe<InputSeasonFindParams>;
  show_ads?: InputMaybe<Scalars['Boolean']['input']>;
  show_series_find_params?: InputMaybe<InputShowSeriesFindParams>;
  sort?: InputMaybe<Array<EnumTvFindParamsSort>>;
  tag_find_params?: InputMaybe<InputTagFindParams>;
  upload_find_params?: InputMaybe<InputUploadFindParams>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  watchable?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputTvPublishBody = {
  action: EnumTvPublishActionType;
  tv: InputTvPublishFields;
};

export type InputTvPublishFields = {
  admin_title?: InputMaybe<Scalars['String']['input']>;
  free_for_subscriber?: InputMaybe<Scalars['Boolean']['input']>;
  genre?: InputMaybe<Array<InputTvPublishGenre>>;
  image?: InputMaybe<Array<InputTvPublishImage>>;
  long_description?: InputMaybe<Scalars['String']['input']>;
  mpaa?: InputMaybe<Array<InputTvPublishMpaa>>;
  owner_user_uuid?: InputMaybe<Scalars['TypeUUID']['input']>;
  person?: InputMaybe<Array<InputTvPublishPerson>>;
  premier_date?: InputMaybe<InputDate>;
  purchasable?: InputMaybe<Scalars['Boolean']['input']>;
  purchase_commission_percent?: InputMaybe<Scalars['Int']['input']>;
  purchase_price_default?: InputMaybe<Scalars['Float']['input']>;
  purchase_price_us?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Array<InputTvPublishRegion>>;
  rent_commission_percent?: InputMaybe<Scalars['Int']['input']>;
  rent_price_default?: InputMaybe<Scalars['Float']['input']>;
  rent_price_us?: InputMaybe<Scalars['Float']['input']>;
  rentable?: InputMaybe<Scalars['Boolean']['input']>;
  search_token?: InputMaybe<Scalars['String']['input']>;
  season?: InputMaybe<Array<InputTvPublishSeason>>;
  short_description?: InputMaybe<Scalars['String']['input']>;
  show_ads?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<Array<InputTvPublishTag>>;
  title?: InputMaybe<Scalars['String']['input']>;
  trailer?: InputMaybe<Array<InputTvPublishTrailer>>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputTvPublishGenre = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputTvPublishImage = {
  is_thumbnail: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputTvPublishMpaa = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputTvPublishPerson = {
  is_actor: Scalars['Boolean']['input'];
  is_creator: Scalars['Boolean']['input'];
  is_director: Scalars['Boolean']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputTvPublishRegion = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputTvPublishSeason = {
  number: Scalars['Int']['input'];
  uuid: Scalars['TypeUUID']['input'];
};

export type InputTvPublishTag = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputTvPublishTrailer = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUploadActionBody = {
  action: EnumUploadActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUploadBody = {
  upload_find_params: InputUploadFindParams;
};

export type InputUploadFindParams = {
  content_types?: InputMaybe<Array<Scalars['String']['input']>>;
  crossword_find_params?: InputMaybe<InputCrosswordFindParams>;
  crossword_series_find_params?: InputMaybe<InputCrosswordSeriesFindParams>;
  date_end?: InputMaybe<InputDate>;
  date_start?: InputMaybe<InputDate>;
  episode_cover_find_params?: InputMaybe<InputEpisodeFindParams>;
  episode_thumbnail_find_params?: InputMaybe<InputEpisodeFindParams>;
  episode_trailer_find_params?: InputMaybe<InputEpisodeFindParams>;
  episode_video_find_params?: InputMaybe<InputEpisodeFindParams>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  is_avatar?: InputMaybe<Scalars['Boolean']['input']>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  movie_cover_find_params?: InputMaybe<InputMovieFindParams>;
  movie_thumbnail_find_params?: InputMaybe<InputMovieFindParams>;
  movie_trailer_find_params?: InputMaybe<InputMovieFindParams>;
  movie_video_find_params?: InputMaybe<InputMovieFindParams>;
  owner_find_params?: InputMaybe<InputUserFindParams>;
  page: Scalars['Int']['input'];
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  person_find_params?: InputMaybe<InputPersonFindParams>;
  profile_find_params?: InputMaybe<InputProfileFindParams>;
  quantity: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
  season_cover_find_params?: InputMaybe<InputSeasonFindParams>;
  season_thumbnail_find_params?: InputMaybe<InputSeasonFindParams>;
  season_trailer_find_params?: InputMaybe<InputSeasonFindParams>;
  show_series_find_params?: InputMaybe<InputShowSeriesFindParams>;
  sort?: InputMaybe<Array<EnumUploadFindParamsSort>>;
  tv_cover_find_params?: InputMaybe<InputTvFindParams>;
  tv_thumbnail_find_params?: InputMaybe<InputTvFindParams>;
  tv_trailer_find_params?: InputMaybe<InputTvFindParams>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputUploadPublishBody = {
  action: EnumUploadPublishActionType;
  upload: InputUploadPublishFields;
};

export type InputUploadPublishFields = {
  already_uploaded_asset_uuid: Scalars['TypeUUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  is_avatar?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputUploadPublishLanguage>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sequence?: InputMaybe<Scalars['Int']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUploadPublishLanguage = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUserActionBody = {
  action: EnumUserActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUserBody = {
  user_find_params: InputUserFindParams;
};

export type InputUserFindParams = {
  credit_voucher_owner_find_params?: InputMaybe<InputCreditVoucherFindParams>;
  credit_voucher_user_find_params?: InputMaybe<InputCreditVoucherFindParams>;
  crossword_find_params?: InputMaybe<InputCrosswordFindParams>;
  date_end?: InputMaybe<InputDate>;
  date_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_start?: InputMaybe<InputDate>;
  domain_envs?: InputMaybe<Array<EnumDomainEnvGql>>;
  email_is_confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  episode_find_params?: InputMaybe<InputEpisodeFindParams>;
  excluded_permission_roles?: InputMaybe<Array<Scalars['String']['input']>>;
  excluded_uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
  facebook_user_names?: InputMaybe<Array<Scalars['String']['input']>>;
  is_approved?: InputMaybe<Scalars['Boolean']['input']>;
  is_banned?: InputMaybe<Scalars['Boolean']['input']>;
  movie_find_params?: InputMaybe<InputMovieFindParams>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  partial_search_string?: InputMaybe<Scalars['String']['input']>;
  permission_roles?: InputMaybe<Array<Scalars['String']['input']>>;
  quantity: Scalars['Int']['input'];
  search_string?: InputMaybe<Scalars['String']['input']>;
  season_find_params?: InputMaybe<InputSeasonFindParams>;
  sort?: InputMaybe<Array<EnumUserFindParamsSort>>;
  tv_find_params?: InputMaybe<InputTvFindParams>;
  twitter_user_names?: InputMaybe<Array<Scalars['String']['input']>>;
  user_names?: InputMaybe<Array<Scalars['String']['input']>>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputUserPublishBody = {
  action: EnumUserPublishActionType;
  user: InputUserPublishFields;
};

export type InputUserPublishFields = {
  biography?: InputMaybe<Scalars['String']['input']>;
  birth_date?: InputMaybe<InputDate>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook_user_name?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Array<InputUserPublishImage>>;
  name?: InputMaybe<Scalars['String']['input']>;
  old_password?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  twitter_user_name?: InputMaybe<Scalars['String']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUserPublishImage = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUserPublishSudoBody = {
  action: EnumUserPublishSudoActionType;
  user: InputUserPublishSudoFields;
};

export type InputUserPublishSudoFields = {
  biography?: InputMaybe<Scalars['String']['input']>;
  birth_date?: InputMaybe<InputDate>;
  coins?: InputMaybe<Scalars['Int']['input']>;
  credits?: InputMaybe<Scalars['Float']['input']>;
  domain_env?: InputMaybe<EnumDomainEnvGql>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_is_confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  facebook_user_name?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Array<InputUserPublishSudoImage>>;
  name?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  permission?: InputMaybe<Array<InputUserPublishSudoPermission>>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  twitter_user_name?: InputMaybe<Scalars['String']['input']>;
  user_name?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUserPublishSudoImage = {
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUserPublishSudoPermission = {
  role: Scalars['String']['input'];
};

export type InputUserShowPurchaseActionBody = {
  action: EnumUserShowPurchaseActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUserShowPurchaseBody = {
  user_show_purchase_find_params: InputUserShowPurchaseFindParams;
};

export type InputUserShowPurchaseFindParams = {
  country_code?: InputMaybe<Scalars['String']['input']>;
  date_end?: InputMaybe<InputDate>;
  date_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_start?: InputMaybe<InputDate>;
  max_price?: InputMaybe<Scalars['Float']['input']>;
  min_price?: InputMaybe<Scalars['Float']['input']>;
  owner_user_find_params?: InputMaybe<InputUserFindParams>;
  page: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  show_find_params?: InputMaybe<InputShowFindParams>;
  sort?: InputMaybe<Array<EnumUserShowPurchaseFindParamsSort>>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputUserShowPurchasePublishBody = {
  action: EnumUserShowPurchasePublishActionType;
  user_show_purchase: InputUserShowPurchasePublishFields;
};

export type InputUserShowPurchasePublishFields = {
  commission_percent?: InputMaybe<Scalars['Int']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  owner_user_uuid?: InputMaybe<Scalars['TypeUUID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  show_uuid?: InputMaybe<Scalars['TypeUUID']['input']>;
  user_uuid?: InputMaybe<Scalars['TypeUUID']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUserShowRentActionBody = {
  action: EnumUserShowRentActionType;
  uuid: Scalars['TypeUUID']['input'];
};

export type InputUserShowRentBody = {
  user_show_rent_find_params: InputUserShowRentFindParams;
};

export type InputUserShowRentFindParams = {
  country_code?: InputMaybe<Scalars['String']['input']>;
  date_end?: InputMaybe<InputDate>;
  date_interval_unit?: InputMaybe<EnumDateIntervalUnit>;
  date_start?: InputMaybe<InputDate>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  max_price?: InputMaybe<Scalars['Float']['input']>;
  min_price?: InputMaybe<Scalars['Float']['input']>;
  owner_user_find_params?: InputMaybe<InputUserFindParams>;
  page: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
  show_find_params?: InputMaybe<InputShowFindParams>;
  sort?: InputMaybe<Array<EnumUserShowRentFindParamsSort>>;
  user_find_params?: InputMaybe<InputUserFindParams>;
  uuids?: InputMaybe<Array<Scalars['TypeUUID']['input']>>;
};

export type InputUserShowRentPublishBody = {
  action: EnumUserShowRentPublishActionType;
  user_show_rent: InputUserShowRentPublishFields;
};

export type InputUserShowRentPublishFields = {
  commission_percent?: InputMaybe<Scalars['Int']['input']>;
  country_code?: InputMaybe<Scalars['String']['input']>;
  owner_user_uuid?: InputMaybe<Scalars['TypeUUID']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  show_uuid?: InputMaybe<Scalars['TypeUUID']['input']>;
  user_uuid?: InputMaybe<Scalars['TypeUUID']['input']>;
  uuid: Scalars['TypeUUID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  accountConfirmEmail: TypeAccountConfirmEmailResults;
  accountCreate: TypeAccountCreateResults;
  accountLogin: TypeAccountLoginResults;
  accountLoginApple: TypeAccountLoginAppleResults;
  accountLoginCode: TypeAccountLoginCodeResults;
  accountLoginFacebook: TypeAccountLoginFacebookResults;
  accountLoginGoogle: TypeAccountLoginGoogleResults;
  accountLogout: TypeAccountLogoutResults;
  accountResetPassword: TypeAccountResetPasswordResults;
  applyCreditVoucher: TypeApplyCreditVoucherResults;
  connectInstagramBusiness: TypeConnectInstagramBusinessResults;
  consumeCreditsAction: TypeConsumeCreditsActionResults;
  createAuthCode: TypeCreateAuthCodeResults;
  createSignedUrlForUpload: TypeSignedUrlForUploadResults;
  creditVoucherAction: TypeCreditVoucherActionResults;
  creditVoucherPublish: TypeCreditVoucherPublishResults;
  crosswordAction: TypeCrosswordActionResults;
  crosswordPublish: TypeCrosswordPublishResults;
  crosswordSeriesAction: TypeCrosswordSeriesActionResults;
  crosswordSeriesPublish: TypeCrosswordSeriesPublishResults;
  crosswordSolutionAction: TypeCrosswordSolutionActionResults;
  crosswordSolutionPlayerAction: TypeCrosswordSolutionPlayerActionResults;
  crosswordSolutionPublish: TypeCrosswordSolutionPublishResults;
  episodeAction: TypeEpisodeActionResults;
  episodePublish: TypeEpisodePublishResults;
  genreAction: TypeGenreActionResults;
  genrePublish: TypeGenrePublishResults;
  languageAction: TypeLanguageActionResults;
  languagePublish: TypeLanguagePublishResults;
  loginAuthCode: TypeLoginAuthCodeResults;
  movieAction: TypeMovieActionResults;
  moviePublish: TypeMoviePublishResults;
  mpaaAction: TypeMpaaActionResults;
  mpaaPublish: TypeMpaaPublishResults;
  personAction: TypePersonActionResults;
  personPublish: TypePersonPublishResults;
  profileAction: TypeProfileActionResults;
  profileLogin: TypeProfileLoginResults;
  profilePublish: TypeProfilePublishResults;
  profileSavedAction: TypeProfileSavedActionResults;
  profileVoteAction: TypeProfileVoteActionResults;
  profileWatchHistoryAction: TypeProfileWatchHistoryActionResults;
  regionAction: TypeRegionActionResults;
  regionPublish: TypeRegionPublishResults;
  savedAction: TypeSavedActionResults;
  scBusinessAction: TypeSCBusinessActionResults;
  scBusinessWorkflowAction: TypeSCBusinessWorkflowActionResults;
  scBusinessWorkflowPublish: TypeSCBusinessWorkflowPublishResults;
  scCommentPublish: TypeSCCommentPublishResults;
  scPostWorkflowAction: TypeSCPostWorkflowActionResults;
  scPostWorkflowPublish: TypeSCPostWorkflowPublishResults;
  seasonAction: TypeSeasonActionResults;
  seasonPublish: TypeSeasonPublishResults;
  sendConfirmEmailLink: TypeSendConfirmEmailLinkResults;
  sendLoginCode: TypeSendLoginCodeResults;
  sendPasswordResetLink: TypeSendPasswordResetLinkResults;
  settingPublish: TypeSettingPublishResults;
  showSeriesAction: TypeShowSeriesActionResults;
  showSeriesPublish: TypeShowSeriesPublishResults;
  tagAction: TypeTagActionResults;
  tagPublish: TypeTagPublishResults;
  tvAction: TypeTvActionResults;
  tvPublish: TypeTvPublishResults;
  uploadAction: TypeUploadActionResults;
  uploadPublish: TypeUploadPublishResults;
  userAction: TypeUserActionResults;
  userPublish: TypeUserPublishResults;
  userPublishSudo: TypeUserPublishSudoResults;
  userShowPurchaseAction: TypeUserShowPurchaseActionResults;
  userShowPurchasePublish: TypeUserShowPurchasePublishResults;
  userShowRentAction: TypeUserShowRentActionResults;
  userShowRentPublish: TypeUserShowRentPublishResults;
  welcomeMutation: Maybe<Scalars['Int']['output']>;
};


export type MutationAccountConfirmEmailArgs = {
  body: InputAccountConfirmEmailBody;
};


export type MutationAccountCreateArgs = {
  body: InputAccountCreateBody;
};


export type MutationAccountLoginArgs = {
  body: InputAccountLoginBody;
};


export type MutationAccountLoginAppleArgs = {
  body: InputAccountLoginAppleBody;
};


export type MutationAccountLoginCodeArgs = {
  body: InputAccountLoginCodeBody;
};


export type MutationAccountLoginFacebookArgs = {
  body: InputAccountLoginFacebookBody;
};


export type MutationAccountLoginGoogleArgs = {
  body: InputAccountLoginGoogleBody;
};


export type MutationAccountResetPasswordArgs = {
  body: InputAccountResetPasswordBody;
};


export type MutationApplyCreditVoucherArgs = {
  body: InputApplyCreditVoucherBody;
};


export type MutationConnectInstagramBusinessArgs = {
  body: InputConnectInstagramBusinessBody;
};


export type MutationConsumeCreditsActionArgs = {
  body: InputConsumeCreditsActionBody;
};


export type MutationCreateAuthCodeArgs = {
  body: InputCreateAuthCodeBody;
};


export type MutationCreateSignedUrlForUploadArgs = {
  body: InputSignedUrlForUpload;
};


export type MutationCreditVoucherActionArgs = {
  body: InputCreditVoucherActionBody;
};


export type MutationCreditVoucherPublishArgs = {
  body: InputCreditVoucherPublishBody;
};


export type MutationCrosswordActionArgs = {
  body: InputCrosswordActionBody;
};


export type MutationCrosswordPublishArgs = {
  body: InputCrosswordPublishBody;
};


export type MutationCrosswordSeriesActionArgs = {
  body: InputCrosswordSeriesActionBody;
};


export type MutationCrosswordSeriesPublishArgs = {
  body: InputCrosswordSeriesPublishBody;
};


export type MutationCrosswordSolutionActionArgs = {
  body: InputCrosswordSolutionActionBody;
};


export type MutationCrosswordSolutionPlayerActionArgs = {
  body: InputCrosswordSolutionPlayerActionBody;
};


export type MutationCrosswordSolutionPublishArgs = {
  body: InputCrosswordSolutionPublishBody;
};


export type MutationEpisodeActionArgs = {
  body: InputEpisodeActionBody;
};


export type MutationEpisodePublishArgs = {
  body: InputEpisodePublishBody;
};


export type MutationGenreActionArgs = {
  body: InputGenreActionBody;
};


export type MutationGenrePublishArgs = {
  body: InputGenrePublishBody;
};


export type MutationLanguageActionArgs = {
  body: InputLanguageActionBody;
};


export type MutationLanguagePublishArgs = {
  body: InputLanguagePublishBody;
};


export type MutationLoginAuthCodeArgs = {
  body: InputLoginAuthCodeBody;
};


export type MutationMovieActionArgs = {
  body: InputMovieActionBody;
};


export type MutationMoviePublishArgs = {
  body: InputMoviePublishBody;
};


export type MutationMpaaActionArgs = {
  body: InputMpaaActionBody;
};


export type MutationMpaaPublishArgs = {
  body: InputMpaaPublishBody;
};


export type MutationPersonActionArgs = {
  body: InputPersonActionBody;
};


export type MutationPersonPublishArgs = {
  body: InputPersonPublishBody;
};


export type MutationProfileActionArgs = {
  body: InputProfileActionBody;
};


export type MutationProfileLoginArgs = {
  body: InputProfileLoginBody;
};


export type MutationProfilePublishArgs = {
  body: InputProfilePublishBody;
};


export type MutationProfileSavedActionArgs = {
  body: InputProfileSavedActionBody;
};


export type MutationProfileVoteActionArgs = {
  body: InputProfileVoteActionBody;
};


export type MutationProfileWatchHistoryActionArgs = {
  body: InputProfileWatchHistoryActionBody;
};


export type MutationRegionActionArgs = {
  body: InputRegionActionBody;
};


export type MutationRegionPublishArgs = {
  body: InputRegionPublishBody;
};


export type MutationSavedActionArgs = {
  body: InputSavedActionBody;
};


export type MutationSCBusinessActionArgs = {
  body: InputSCBusinessActionBody;
};


export type MutationSCBusinessWorkflowActionArgs = {
  body: InputSCBusinessWorkflowActionBody;
};


export type MutationSCBusinessWorkflowPublishArgs = {
  body: InputSCBusinessWorkflowPublishBody;
};


export type MutationSCCommentPublishArgs = {
  body: InputSCCommentPublishBody;
};


export type MutationSCPostWorkflowActionArgs = {
  body: InputSCPostWorkflowActionBody;
};


export type MutationSCPostWorkflowPublishArgs = {
  body: InputSCPostWorkflowPublishBody;
};


export type MutationSeasonActionArgs = {
  body: InputSeasonActionBody;
};


export type MutationSeasonPublishArgs = {
  body: InputSeasonPublishBody;
};


export type MutationSendConfirmEmailLinkArgs = {
  body: InputSendConfirmEmailLinkBody;
};


export type MutationSendLoginCodeArgs = {
  body: InputSendLoginCodeBody;
};


export type MutationSendPasswordResetLinkArgs = {
  body: InputSendPasswordResetLinkBody;
};


export type MutationSettingPublishArgs = {
  body: InputSettingPublishBody;
};


export type MutationShowSeriesActionArgs = {
  body: InputShowSeriesActionBody;
};


export type MutationShowSeriesPublishArgs = {
  body: InputShowSeriesPublishBody;
};


export type MutationTagActionArgs = {
  body: InputTagActionBody;
};


export type MutationTagPublishArgs = {
  body: InputTagPublishBody;
};


export type MutationTvActionArgs = {
  body: InputTvActionBody;
};


export type MutationTvPublishArgs = {
  body: InputTvPublishBody;
};


export type MutationUploadActionArgs = {
  body: InputUploadActionBody;
};


export type MutationUploadPublishArgs = {
  body: InputUploadPublishBody;
};


export type MutationUserActionArgs = {
  body: InputUserActionBody;
};


export type MutationUserPublishArgs = {
  body: InputUserPublishBody;
};


export type MutationUserPublishSudoArgs = {
  body: InputUserPublishSudoBody;
};


export type MutationUserShowPurchaseActionArgs = {
  body: InputUserShowPurchaseActionBody;
};


export type MutationUserShowPurchasePublishArgs = {
  body: InputUserShowPurchasePublishBody;
};


export type MutationUserShowRentActionArgs = {
  body: InputUserShowRentActionBody;
};


export type MutationUserShowRentPublishArgs = {
  body: InputUserShowRentPublishBody;
};

export type Query = {
  __typename?: 'Query';
  authCode: TypeAuthCodeResults;
  country: Maybe<TypeCountry>;
  creditVouchers: TypeCreditVoucherResults;
  crosswordByID: Maybe<TypeCrossword>;
  crosswordByUUID: Maybe<TypeCrossword>;
  crosswordSeries: TypeCrosswordSeriesResults;
  crosswordSeriesByUUID: Maybe<TypeCrosswordSeries>;
  crosswordSolutionByUUID: Maybe<TypeCrosswordSolution>;
  crosswordSolutions: TypeCrosswordSolutionResults;
  crosswords: TypeCrosswordResults;
  currency: TypeCurrencyResults;
  episodeByUUID: Maybe<TypeEpisode>;
  episodes: TypeEpisodeResults;
  genreByUUID: Maybe<TypeGenre>;
  genres: TypeGenreResults;
  languageByUUID: Maybe<TypeLanguage>;
  languages: TypeLanguageResults;
  movieByUUID: Maybe<TypeMovie>;
  movies: TypeMovieResults;
  mpaaByUUID: Maybe<TypeMpaa>;
  mpaas: TypeMpaaResults;
  pageCrossword: TypePageCrosswordResults;
  pageEntry: TypePageEntryResults;
  pageShow: TypePageShowResults;
  pageSwift: TypePageScResults;
  personByUUID: Maybe<TypePerson>;
  personByUsername: Maybe<TypePerson>;
  persons: TypePersonResults;
  profileByUUID: Maybe<TypeProfile>;
  profileSaved: TypeProfileSavedResults;
  profileVote: TypeProfileVoteResults;
  profileWatchHistory: TypeProfileWatchHistoryResults;
  profiles: TypeProfileResults;
  regionBySlug: Maybe<TypeRegion>;
  regionByUUID: Maybe<TypeRegion>;
  regions: TypeRegionResults;
  saved: TypeSavedResults;
  scApiComment: Maybe<TypeSCApiComment>;
  scApiPost: Maybe<TypeSCApiPost>;
  scBusiness: Maybe<TypeSCBusiness>;
  scBusinessWorkflow: Maybe<TypeSCBusinessWorkflow>;
  scPostWorkflow: Maybe<TypeSCPostWorkflow>;
  scUserApiPosts: TypeSCUserApiPosts;
  seasonByUUID: Maybe<TypeSeason>;
  seasons: TypeSeasonResults;
  settings: TypeSettingResults;
  showSeries: TypeShowSeriesResults;
  showSeriesBySlug: Maybe<TypeShowSeries>;
  showSeriesByUUID: Maybe<TypeShowSeries>;
  shows: TypeShowResults;
  tagBySlug: Maybe<TypeTag>;
  tagByUUID: Maybe<TypeTag>;
  tags: TypeTagResults;
  tvByUUID: Maybe<TypeTv>;
  tvs: TypeTvResults;
  uploadByUUID: Maybe<TypeUpload>;
  uploads: TypeUploadResults;
  uploadsByUUID: Array<Maybe<TypeUpload>>;
  userByUUID: Maybe<TypeUser>;
  userByUsername: Maybe<TypeUser>;
  userShowPurchase: TypeUserShowPurchaseResults;
  userShowPurchaseStatistics: TypeUserShowPurchaseStatisticsResults;
  userShowRent: TypeUserShowRentResults;
  userShowRentStatistics: TypeUserShowRentStatisticsResults;
  users: TypeUserResults;
  viewer: Maybe<TypeUser>;
  viewerProfile: Maybe<TypeProfile>;
  viewerProfiles: Array<TypeProfile>;
  welcomeQuery: Maybe<Scalars['Int']['output']>;
};


export type QueryAuthCodeArgs = {
  body: InputAuthCodeBody;
};


export type QueryCreditVouchersArgs = {
  body: InputCreditVoucherBody;
};


export type QueryCrosswordByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCrosswordByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryCrosswordSeriesArgs = {
  body: InputCrosswordSeriesBody;
};


export type QueryCrosswordSeriesByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryCrosswordSolutionByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryCrosswordSolutionsArgs = {
  body: InputCrosswordSolutionBody;
};


export type QueryCrosswordsArgs = {
  body: InputCrosswordBody;
};


export type QueryEpisodeByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryEpisodesArgs = {
  body: InputEpisodeBody;
};


export type QueryGenreByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryGenresArgs = {
  body: InputGenreBody;
};


export type QueryLanguageByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryLanguagesArgs = {
  body: InputLanguageBody;
};


export type QueryMovieByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryMoviesArgs = {
  body: InputMovieBody;
};


export type QueryMpaaByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryMpaasArgs = {
  body: InputMpaaBody;
};


export type QueryPersonByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryPersonByUsernameArgs = {
  user_name: Scalars['String']['input'];
};


export type QueryPersonsArgs = {
  body: InputPersonBody;
};


export type QueryProfileByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryProfileSavedArgs = {
  body: InputProfileSavedBody;
};


export type QueryProfileVoteArgs = {
  body: InputProfileVoteBody;
};


export type QueryProfileWatchHistoryArgs = {
  body: InputProfileWatchHistoryBody;
};


export type QueryProfilesArgs = {
  body: InputProfileBody;
};


export type QueryRegionBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryRegionByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryRegionsArgs = {
  body: InputRegionBody;
};


export type QuerySavedArgs = {
  body: InputSavedBody;
};


export type QuerySCApiCommentArgs = {
  business_id: Scalars['String']['input'];
  comment_id: Scalars['String']['input'];
};


export type QuerySCApiPostArgs = {
  business_id: Scalars['String']['input'];
  post_id: Scalars['String']['input'];
};


export type QuerySCBusinessArgs = {
  business_id: Scalars['String']['input'];
};


export type QuerySCBusinessWorkflowArgs = {
  business_id: Scalars['String']['input'];
};


export type QuerySCPostWorkflowArgs = {
  post_id: Scalars['String']['input'];
};


export type QuerySeasonByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QuerySeasonsArgs = {
  body: InputSeasonBody;
};


export type QuerySettingsArgs = {
  body: InputSettingBody;
};


export type QueryShowSeriesArgs = {
  body: InputShowSeriesBody;
};


export type QueryShowSeriesBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryShowSeriesByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryShowsArgs = {
  body: InputShowBody;
};


export type QueryTagBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryTagByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryTagsArgs = {
  body: InputTagBody;
};


export type QueryTvByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryTvsArgs = {
  body: InputTvBody;
};


export type QueryUploadByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryUploadsArgs = {
  body: InputUploadBody;
};


export type QueryUploadsByUuidArgs = {
  uuids: Array<Scalars['TypeUUID']['input']>;
};


export type QueryUserByUuidArgs = {
  uuid: Scalars['TypeUUID']['input'];
};


export type QueryUserByUsernameArgs = {
  user_name: Scalars['String']['input'];
};


export type QueryUserShowPurchaseArgs = {
  body: InputUserShowPurchaseBody;
};


export type QueryUserShowRentArgs = {
  body: InputUserShowRentBody;
};


export type QueryUsersArgs = {
  body: InputUserBody;
};

export type TypeAccountConfirmEmailResults = {
  __typename?: 'TypeAccountConfirmEmailResults';
  data: Maybe<TypeAccountConfirmEmailResultsData>;
};

export type TypeAccountConfirmEmailResultsData = {
  __typename?: 'TypeAccountConfirmEmailResultsData';
  status: Scalars['Boolean']['output'];
};

export type TypeAccountCreateResults = {
  __typename?: 'TypeAccountCreateResults';
  data: Maybe<TypeAccountCreateResultsData>;
};

export type TypeAccountCreateResultsData = {
  __typename?: 'TypeAccountCreateResultsData';
  token: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeAccountLoginAppleResults = {
  __typename?: 'TypeAccountLoginAppleResults';
  data: Maybe<TypeAccountLoginAppleResultsData>;
};

export type TypeAccountLoginAppleResultsData = {
  __typename?: 'TypeAccountLoginAppleResultsData';
  token: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeAccountLoginCodeResults = {
  __typename?: 'TypeAccountLoginCodeResults';
  data: Maybe<TypeAccountLoginCodeResultsData>;
};

export type TypeAccountLoginCodeResultsData = {
  __typename?: 'TypeAccountLoginCodeResultsData';
  token: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeAccountLoginFacebookResults = {
  __typename?: 'TypeAccountLoginFacebookResults';
  data: Maybe<TypeAccountLoginFacebookResultsData>;
};

export type TypeAccountLoginFacebookResultsData = {
  __typename?: 'TypeAccountLoginFacebookResultsData';
  token: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeAccountLoginGoogleResults = {
  __typename?: 'TypeAccountLoginGoogleResults';
  data: Maybe<TypeAccountLoginGoogleResultsData>;
};

export type TypeAccountLoginGoogleResultsData = {
  __typename?: 'TypeAccountLoginGoogleResultsData';
  token: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeAccountLoginResults = {
  __typename?: 'TypeAccountLoginResults';
  data: Maybe<TypeAccountLoginResultsData>;
};

export type TypeAccountLoginResultsData = {
  __typename?: 'TypeAccountLoginResultsData';
  token: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeAccountLogoutResults = {
  __typename?: 'TypeAccountLogoutResults';
  data: Maybe<TypeAccountLogoutResultsData>;
};

export type TypeAccountLogoutResultsData = {
  __typename?: 'TypeAccountLogoutResultsData';
  status: Scalars['Boolean']['output'];
};

export type TypeAccountResetPasswordResults = {
  __typename?: 'TypeAccountResetPasswordResults';
  data: Maybe<TypeAccountResetPasswordResultsData>;
};

export type TypeAccountResetPasswordResultsData = {
  __typename?: 'TypeAccountResetPasswordResultsData';
  token: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeAppHelmet = {
  __typename?: 'TypeAppHelmet';
  canonical_url: Scalars['String']['output'];
  description: Scalars['String']['output'];
  disable_google_index: Maybe<Scalars['Boolean']['output']>;
  image: Maybe<TypeAppHelmetImage>;
  jsonld: Maybe<Scalars['String']['output']>;
  modified_time: Maybe<TypeDate>;
  published_time: Maybe<TypeDate>;
  title: Scalars['String']['output'];
  video_mp4: Maybe<TypeAppHelmetVideoMp4>;
};

export type TypeAppHelmetImage = {
  __typename?: 'TypeAppHelmetImage';
  dimensions: Maybe<TypeAppHelmetImageDimensions>;
  thumbnail_url: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type TypeAppHelmetImageDimensions = {
  __typename?: 'TypeAppHelmetImageDimensions';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type TypeAppHelmetVideoMp4 = {
  __typename?: 'TypeAppHelmetVideoMp4';
  url: Scalars['String']['output'];
};

export type TypeApplyCreditVoucherResults = {
  __typename?: 'TypeApplyCreditVoucherResults';
  data: Maybe<TypeApplyCreditVoucherResultsData>;
};

export type TypeApplyCreditVoucherResultsData = {
  __typename?: 'TypeApplyCreditVoucherResultsData';
  status: Scalars['Boolean']['output'];
};

export type TypeAuthCodeResults = {
  __typename?: 'TypeAuthCodeResults';
  data: Maybe<TypeAuthCodeResultsData>;
};

export type TypeAuthCodeResultsData = {
  __typename?: 'TypeAuthCodeResultsData';
  token: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeConnectInstagramBusinessResults = {
  __typename?: 'TypeConnectInstagramBusinessResults';
  data: TypeSCBusiness;
};

export type TypeConsumeCreditsActionResults = {
  __typename?: 'TypeConsumeCreditsActionResults';
  data: Maybe<TypeConsumeCreditsActionResultsData>;
};

export type TypeConsumeCreditsActionResultsData = {
  __typename?: 'TypeConsumeCreditsActionResultsData';
  status: Scalars['Boolean']['output'];
};

export type TypeCountry = {
  __typename?: 'TypeCountry';
  code: Scalars['String']['output'];
  dial_code: Scalars['String']['output'];
  is_tanzania: Scalars['Boolean']['output'];
  is_united_states: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type TypeCreateAuthCodeResults = {
  __typename?: 'TypeCreateAuthCodeResults';
  data: Maybe<TypeCreateAuthCodeResultsData>;
};

export type TypeCreateAuthCodeResultsData = {
  __typename?: 'TypeCreateAuthCodeResultsData';
  code: Scalars['String']['output'];
};

export type TypeCreditVoucher = {
  __typename?: 'TypeCreditVoucher';
  analytics_single: Maybe<TypeCreditVoucherSingleStatistics>;
  code: Scalars['String']['output'];
  created_at: TypeDate;
  credits: Scalars['Float']['output'];
  description: Maybe<Scalars['String']['output']>;
  end_time: TypeDate;
  max_uses: Scalars['Int']['output'];
  max_uses_user: Scalars['Int']['output'];
  name: Maybe<Scalars['String']['output']>;
  start_time: TypeDate;
  updated_at: TypeDate;
  user: Maybe<TypeUser>;
  uses: Scalars['Int']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeCreditVoucherActionResults = {
  __typename?: 'TypeCreditVoucherActionResults';
  data: Maybe<TypeCreditVoucher>;
};

export type TypeCreditVoucherMultipleStatistics = {
  __typename?: 'TypeCreditVoucherMultipleStatistics';
  last_7_days: TypeCreditVoucherMultipleStatisticsStatistic;
  last_30_days: TypeCreditVoucherMultipleStatisticsStatistic;
  last_365_days: TypeCreditVoucherMultipleStatisticsStatistic;
  this_month: TypeCreditVoucherMultipleStatisticsStatistic;
  this_week: TypeCreditVoucherMultipleStatisticsStatistic;
  this_year: TypeCreditVoucherMultipleStatisticsStatistic;
  today: TypeCreditVoucherMultipleStatisticsStatistic;
  yesterday: TypeCreditVoucherMultipleStatisticsStatistic;
};

export type TypeCreditVoucherMultipleStatisticsStatistic = {
  __typename?: 'TypeCreditVoucherMultipleStatisticsStatistic';
  total_credits: Scalars['Float']['output'];
  total_credits_fulfilled: Scalars['Float']['output'];
  total_quantity: Scalars['Int']['output'];
  total_uses: Scalars['Int']['output'];
};

export type TypeCreditVoucherPublishResults = {
  __typename?: 'TypeCreditVoucherPublishResults';
  data: Maybe<TypeCreditVoucher>;
};

export type TypeCreditVoucherResults = {
  __typename?: 'TypeCreditVoucherResults';
  data: Maybe<TypeCreditVoucherResultsData>;
};

export type TypeCreditVoucherResultsData = {
  __typename?: 'TypeCreditVoucherResultsData';
  items: Array<TypeCreditVoucher>;
  paging: TypePaging;
};

export type TypeCreditVoucherSingleStatistics = {
  __typename?: 'TypeCreditVoucherSingleStatistics';
  total_credits_fulfilled: Scalars['Float']['output'];
  total_uses: Scalars['Int']['output'];
  user: TypeUserResultsData;
  uuid: Scalars['TypeUUID']['output'];
};


export type TypeCreditVoucherSingleStatisticsUserArgs = {
  body: InputUserBody;
};

export type TypeCrossword = {
  __typename?: 'TypeCrossword';
  author: TypeUserResultsData;
  author_direct: Array<TypeUser>;
  category_types: Array<Scalars['String']['output']>;
  created_at: TypeDate;
  created_at_human: Scalars['String']['output'];
  crossword_series: TypeCrosswordSeriesResultsData;
  crossword_solution: TypeCrosswordSolutionResultsData;
  crossword_solution_direct: Maybe<TypeCrosswordSolution>;
  data: TypeCrosswordData;
  fallback_image_path: Scalars['String']['output'];
  image: TypeUploadResultsData;
  image_direct: Array<TypeUploadImage>;
  image_on_view: Maybe<TypeUploadImage>;
  is_active: Scalars['Boolean']['output'];
  is_banned: Scalars['Boolean']['output'];
  is_published: Scalars['Boolean']['output'];
  is_saved: Scalars['Boolean']['output'];
  is_today: Scalars['Boolean']['output'];
  is_trashed: Scalars['Boolean']['output'];
  long_description: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  region: TypeRegionResultsData;
  region_direct: Array<TypeRegion>;
  setter: TypePersonResultsData;
  setter_direct: Array<TypePerson>;
  short_description: Maybe<Scalars['String']['output']>;
  show_ads: Scalars['Boolean']['output'];
  strict_mode: Scalars['Boolean']['output'];
  tag: TypeTagResultsData;
  tag_direct: Array<TypeTag>;
  title: Scalars['String']['output'];
  title_with_number: Scalars['String']['output'];
  updated_at: TypeDate;
  updated_at_human: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
  version_uuid: Maybe<Scalars['TypeUUID']['output']>;
};


export type TypeCrosswordAuthorArgs = {
  body: InputUserBody;
};


export type TypeCrosswordCrosswordSeriesArgs = {
  body: InputCrosswordSeriesBody;
};


export type TypeCrosswordCrosswordSolutionArgs = {
  body: InputCrosswordSolutionBody;
};


export type TypeCrosswordImageArgs = {
  body: InputUploadBody;
};


export type TypeCrosswordRegionArgs = {
  body: InputRegionBody;
};


export type TypeCrosswordSetterArgs = {
  body: InputPersonBody;
};


export type TypeCrosswordTagArgs = {
  body: InputTagBody;
};

export type TypeCrosswordActionResults = {
  __typename?: 'TypeCrosswordActionResults';
  data: Maybe<TypeCrossword>;
};

export type TypeCrosswordCell = {
  __typename?: 'TypeCrosswordCell';
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type TypeCrosswordData = {
  __typename?: 'TypeCrosswordData';
  clues: Scalars['TypeCrosswordClues']['output'];
  dimensions: TypeCrosswordDimensions;
  entries: TypeCrosswordEntries;
  values: Scalars['TypeCrosswordValues']['output'];
};

export type TypeCrosswordDimensions = {
  __typename?: 'TypeCrosswordDimensions';
  height: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type TypeCrosswordEditable = {
  __typename?: 'TypeCrosswordEditable';
  path: Scalars['String']['output'];
  status: Scalars['Boolean']['output'];
};

export type TypeCrosswordEntries = {
  __typename?: 'TypeCrosswordEntries';
  across: Array<TypeCrosswordEntry>;
  down: Array<TypeCrosswordEntry>;
};

export type TypeCrosswordEntry = {
  __typename?: 'TypeCrosswordEntry';
  direction: Scalars['String']['output'];
  end: TypeCrosswordCell;
  human_index: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  length: Scalars['Int']['output'];
  start: TypeCrosswordCell;
  value: Scalars['String']['output'];
};

export type TypeCrosswordPublishCategory = {
  __typename?: 'TypeCrosswordPublishCategory';
  type: Scalars['String']['output'];
};

export type TypeCrosswordPublishFields = {
  __typename?: 'TypeCrosswordPublishFields';
  category: Maybe<Array<TypeCrosswordPublishCategory>>;
  data: Maybe<TypeCrosswordData>;
  image: Maybe<Array<TypeCrosswordPublishImage>>;
  long_description: Maybe<Scalars['String']['output']>;
  region: Maybe<Array<TypeCrosswordPublishRegion>>;
  short_description: Maybe<Scalars['String']['output']>;
  show_ads: Maybe<Scalars['Boolean']['output']>;
  tag: Maybe<Array<TypeCrosswordPublishTag>>;
  title: Maybe<Scalars['String']['output']>;
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeCrosswordPublishImage = {
  __typename?: 'TypeCrosswordPublishImage';
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeCrosswordPublishRegion = {
  __typename?: 'TypeCrosswordPublishRegion';
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeCrosswordPublishResults = {
  __typename?: 'TypeCrosswordPublishResults';
  data: Maybe<TypeCrossword>;
};

export type TypeCrosswordPublishTag = {
  __typename?: 'TypeCrosswordPublishTag';
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeCrosswordResults = {
  __typename?: 'TypeCrosswordResults';
  data: Maybe<TypeCrosswordResultsData>;
};

export type TypeCrosswordResultsData = {
  __typename?: 'TypeCrosswordResultsData';
  items: Array<TypeCrossword>;
  paging: TypePaging;
};

export type TypeCrosswordSeries = {
  __typename?: 'TypeCrosswordSeries';
  created_at: TypeDate;
  crossword: TypeCrosswordSeriesCrosswordResultsData;
  crossword_direct: Array<TypeCrossword>;
  description: Maybe<Scalars['String']['output']>;
  description_rich: Maybe<Scalars['String']['output']>;
  end_time: TypeDate;
  fallback_image_path: Scalars['String']['output'];
  has_ended: Scalars['Boolean']['output'];
  has_started: Scalars['Boolean']['output'];
  image: TypeUploadResultsData;
  image_direct: Array<TypeUploadImage>;
  image_on_view: Maybe<TypeUploadImage>;
  is_active: Scalars['Boolean']['output'];
  is_published: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  start_time: TypeDate;
  type: Scalars['String']['output'];
  updated_at: TypeDate;
  user: Maybe<TypeUser>;
  user_uuid: Maybe<Scalars['TypeUUID']['output']>;
  uuid: Scalars['TypeUUID']['output'];
};


export type TypeCrosswordSeriesCrosswordArgs = {
  body: InputCrosswordSeriesCrosswordBody;
};


export type TypeCrosswordSeriesImageArgs = {
  body: InputUploadBody;
};

export type TypeCrosswordSeriesActionResults = {
  __typename?: 'TypeCrosswordSeriesActionResults';
  data: Maybe<TypeCrosswordSeries>;
};

export type TypeCrosswordSeriesCrosswordResultsData = {
  __typename?: 'TypeCrosswordSeriesCrosswordResultsData';
  items: Array<TypeCrossword>;
  paging: TypePaging;
};

export type TypeCrosswordSeriesPublishResults = {
  __typename?: 'TypeCrosswordSeriesPublishResults';
  data: Maybe<TypeCrosswordSeries>;
};

export type TypeCrosswordSeriesResults = {
  __typename?: 'TypeCrosswordSeriesResults';
  data: Maybe<TypeCrosswordSeriesResultsData>;
};

export type TypeCrosswordSeriesResultsData = {
  __typename?: 'TypeCrosswordSeriesResultsData';
  items: Array<TypeCrosswordSeries>;
  paging: TypePaging;
};

export type TypeCrosswordSolution = {
  __typename?: 'TypeCrosswordSolution';
  completed_at: Maybe<TypeDate>;
  created_at: TypeDate;
  crossword: Maybe<TypeCrossword>;
  crossword_uuid: Maybe<Scalars['TypeUUID']['output']>;
  data: TypeCrosswordSolutionData;
  has_revealed_all: Scalars['Boolean']['output'];
  has_revealed_any: Scalars['Boolean']['output'];
  is_complete: Scalars['Boolean']['output'];
  score: Scalars['Int']['output'];
  updated_at: TypeDate;
  user: Maybe<TypeUser>;
  user_uuid: Scalars['TypeUUID']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeCrosswordSolutionActionResults = {
  __typename?: 'TypeCrosswordSolutionActionResults';
  data: Maybe<TypeCrosswordSolution>;
};

export type TypeCrosswordSolutionData = {
  __typename?: 'TypeCrosswordSolutionData';
  player_actions: Maybe<Scalars['TypeCrosswordSolutionPlayerActions']['output']>;
  player_values: Scalars['TypeCrosswordSolutionPlayerValues']['output'];
  player_values_metadata: Maybe<Scalars['TypeCrosswordSolutionPlayerValuesMetadata']['output']>;
};

export type TypeCrosswordSolutionPlayerActionResults = {
  __typename?: 'TypeCrosswordSolutionPlayerActionResults';
  data: Maybe<TypeCrosswordSolution>;
};

export type TypeCrosswordSolutionPublishResults = {
  __typename?: 'TypeCrosswordSolutionPublishResults';
  data: Maybe<TypeCrosswordSolution>;
};

export type TypeCrosswordSolutionResults = {
  __typename?: 'TypeCrosswordSolutionResults';
  data: Maybe<TypeCrosswordSolutionResultsData>;
};

export type TypeCrosswordSolutionResultsData = {
  __typename?: 'TypeCrosswordSolutionResultsData';
  items: Array<TypeCrosswordSolution>;
  paging: TypePaging;
};

export type TypeCurrencyResults = {
  __typename?: 'TypeCurrencyResults';
  data: Maybe<TypeCurrencyResultsData>;
};

export type TypeCurrencyResultsData = {
  __typename?: 'TypeCurrencyResultsData';
  usd_tzs: Scalars['Int']['output'];
};

export type TypeDate = {
  __typename?: 'TypeDate';
  iso: Scalars['TypeDateIso']['output'];
};

export type TypeEpisode = {
  __typename?: 'TypeEpisode';
  abbreviation: Maybe<TypeEpisodeAbbreviation>;
  actor: TypePersonResultsData;
  actor_direct: Array<TypePerson>;
  admin_title: Maybe<Scalars['String']['output']>;
  author: TypeUserResultsData;
  author_direct: Array<TypeUser>;
  cover: TypeUploadResultsData;
  cover_direct: Array<TypeUploadImage>;
  cover_on_view: Maybe<TypeUploadImage>;
  created_at: TypeDate;
  created_at_human: Scalars['String']['output'];
  creator: TypePersonResultsData;
  creator_direct: Array<TypePerson>;
  director: TypePersonResultsData;
  director_direct: Array<TypePerson>;
  fallback_cover_path: Scalars['String']['output'];
  fallback_thumbnail_path: Scalars['String']['output'];
  free_for_subscriber: Scalars['Boolean']['output'];
  has_premiered: Scalars['Boolean']['output'];
  is_active: Scalars['Boolean']['output'];
  is_banned: Scalars['Boolean']['output'];
  is_published: Scalars['Boolean']['output'];
  is_trashed: Scalars['Boolean']['output'];
  long_description: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  play: Maybe<TypeEpisode>;
  premier_date: TypeDate;
  premier_date_human: Scalars['String']['output'];
  progress: Maybe<Scalars['Float']['output']>;
  purchasable: Scalars['Boolean']['output'];
  purchase_price: Scalars['Float']['output'];
  purchase_price_default: Scalars['Float']['output'];
  purchase_price_us: Maybe<Scalars['Float']['output']>;
  purchased: Maybe<Scalars['Boolean']['output']>;
  rent_price: Scalars['Float']['output'];
  rent_price_default: Scalars['Float']['output'];
  rent_price_us: Maybe<Scalars['Float']['output']>;
  rentable: Scalars['Boolean']['output'];
  rented: Maybe<TypeEpisodeRent>;
  resume: Maybe<TypeEpisode>;
  runtime_human: Maybe<Scalars['String']['output']>;
  runtime_seconds: Maybe<Scalars['Int']['output']>;
  season: TypeSeasonResultsData;
  season_watchable: Maybe<TypeSeason>;
  short_description: Maybe<Scalars['String']['output']>;
  show_ads: Scalars['Boolean']['output'];
  thumbnail: TypeUploadResultsData;
  thumbnail_direct: Array<TypeUploadImage>;
  thumbnail_on_view: Maybe<TypeUploadImage>;
  title: Scalars['String']['output'];
  trailer: TypeUploadResultsData;
  trailer_direct: Array<TypeUploadVideo>;
  trailer_on_view: Maybe<TypeUploadVideo>;
  tv: TypeTvResultsData;
  tv_watchable: Maybe<TypeTv>;
  updated_at: TypeDate;
  updated_at_human: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
  version_uuid: Maybe<Scalars['TypeUUID']['output']>;
  video: TypeUploadResultsData;
  video_direct: Array<TypeUploadVideo>;
  watchable: Scalars['Boolean']['output'];
};


export type TypeEpisodeActorArgs = {
  body: InputPersonBody;
};


export type TypeEpisodeAuthorArgs = {
  body: InputUserBody;
};


export type TypeEpisodeCoverArgs = {
  body: InputUploadBody;
};


export type TypeEpisodeCreatorArgs = {
  body: InputPersonBody;
};


export type TypeEpisodeDirectorArgs = {
  body: InputPersonBody;
};


export type TypeEpisodeSeasonArgs = {
  body: InputSeasonBody;
};


export type TypeEpisodeThumbnailArgs = {
  body: InputUploadBody;
};


export type TypeEpisodeTrailerArgs = {
  body: InputUploadBody;
};


export type TypeEpisodeTvArgs = {
  body: InputTvBody;
};


export type TypeEpisodeVideoArgs = {
  body: InputUploadBody;
};

export type TypeEpisodeAbbreviation = {
  __typename?: 'TypeEpisodeAbbreviation';
  long: Scalars['String']['output'];
  short: Scalars['String']['output'];
};

export type TypeEpisodeActionResults = {
  __typename?: 'TypeEpisodeActionResults';
  data: Maybe<TypeEpisode>;
};

export type TypeEpisodePublishResults = {
  __typename?: 'TypeEpisodePublishResults';
  data: Maybe<TypeEpisode>;
};

export type TypeEpisodeRent = {
  __typename?: 'TypeEpisodeRent';
  expires_in_hours: Scalars['Int']['output'];
};

export type TypeEpisodeResults = {
  __typename?: 'TypeEpisodeResults';
  data: Maybe<TypeEpisodeResultsData>;
};

export type TypeEpisodeResultsData = {
  __typename?: 'TypeEpisodeResultsData';
  items: Array<TypeEpisode>;
  paging: TypePaging;
};

export type TypeGenre = {
  __typename?: 'TypeGenre';
  created_at: TypeDate;
  description: Maybe<Scalars['String']['output']>;
  movie: TypeMovieResultsData;
  name: Scalars['String']['output'];
  tv: TypeTvResultsData;
  updated_at: TypeDate;
  uuid: Scalars['TypeUUID']['output'];
};


export type TypeGenreMovieArgs = {
  body: InputMovieBody;
};


export type TypeGenreTvArgs = {
  body: InputTvBody;
};

export type TypeGenreActionResults = {
  __typename?: 'TypeGenreActionResults';
  data: Maybe<TypeGenre>;
};

export type TypeGenrePublishResults = {
  __typename?: 'TypeGenrePublishResults';
  data: Maybe<TypeGenre>;
};

export type TypeGenreResults = {
  __typename?: 'TypeGenreResults';
  data: Maybe<TypeGenreResultsData>;
};

export type TypeGenreResultsData = {
  __typename?: 'TypeGenreResultsData';
  items: Array<TypeGenre>;
  paging: TypePaging;
};

export type TypeLanguage = {
  __typename?: 'TypeLanguage';
  created_at: TypeDate;
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updated_at: TypeDate;
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeLanguageActionResults = {
  __typename?: 'TypeLanguageActionResults';
  data: Maybe<TypeLanguage>;
};

export type TypeLanguagePublishResults = {
  __typename?: 'TypeLanguagePublishResults';
  data: Maybe<TypeLanguage>;
};

export type TypeLanguageResults = {
  __typename?: 'TypeLanguageResults';
  data: Maybe<TypeLanguageResultsData>;
};

export type TypeLanguageResultsData = {
  __typename?: 'TypeLanguageResultsData';
  items: Array<TypeLanguage>;
  paging: TypePaging;
};

export type TypeLoginAuthCodeResults = {
  __typename?: 'TypeLoginAuthCodeResults';
  data: Maybe<TypeLoginAuthCodeResultsData>;
};

export type TypeLoginAuthCodeResultsData = {
  __typename?: 'TypeLoginAuthCodeResultsData';
  status: Scalars['Boolean']['output'];
};

export type TypeMovie = {
  __typename?: 'TypeMovie';
  actor: TypePersonResultsData;
  actor_direct: Array<TypePerson>;
  admin_title: Maybe<Scalars['String']['output']>;
  author: TypeUserResultsData;
  author_direct: Array<TypeUser>;
  cover: TypeUploadResultsData;
  cover_direct: Array<TypeUploadImage>;
  cover_on_view: Maybe<TypeUploadImage>;
  created_at: TypeDate;
  created_at_human: Scalars['String']['output'];
  creator: TypePersonResultsData;
  creator_direct: Array<TypePerson>;
  director: TypePersonResultsData;
  director_direct: Array<TypePerson>;
  fallback_cover_path: Scalars['String']['output'];
  fallback_thumbnail_path: Scalars['String']['output'];
  free_for_subscriber: Scalars['Boolean']['output'];
  genre: TypeGenreResultsData;
  genre_direct: Array<TypeGenre>;
  has_premiered: Scalars['Boolean']['output'];
  is_active: Scalars['Boolean']['output'];
  is_banned: Scalars['Boolean']['output'];
  is_published: Scalars['Boolean']['output'];
  is_trashed: Scalars['Boolean']['output'];
  long_description: Maybe<Scalars['String']['output']>;
  mpaa: TypeMpaaResultsData;
  mpaa_direct: Array<TypeMpaa>;
  owner_user: Maybe<TypeUser>;
  owner_user_uuid: Maybe<Scalars['TypeUUID']['output']>;
  path: Scalars['String']['output'];
  play: Maybe<TypeMovie>;
  premier_date: TypeDate;
  premier_date_human: Scalars['String']['output'];
  progress: Maybe<Scalars['Float']['output']>;
  purchasable: Scalars['Boolean']['output'];
  purchase_commission_percent: Scalars['Int']['output'];
  purchase_price: Scalars['Float']['output'];
  purchase_price_default: Scalars['Float']['output'];
  purchase_price_us: Maybe<Scalars['Float']['output']>;
  purchased: Maybe<Scalars['Boolean']['output']>;
  region: TypeRegionResultsData;
  region_direct: Array<TypeRegion>;
  rent_commission_percent: Scalars['Int']['output'];
  rent_price: Scalars['Float']['output'];
  rent_price_default: Scalars['Float']['output'];
  rent_price_us: Maybe<Scalars['Float']['output']>;
  rentable: Scalars['Boolean']['output'];
  rented: Maybe<TypeMovieRent>;
  resume: Maybe<TypeMovie>;
  runtime_human: Maybe<Scalars['String']['output']>;
  runtime_seconds: Maybe<Scalars['Int']['output']>;
  search_token: Maybe<Scalars['String']['output']>;
  short_description: Maybe<Scalars['String']['output']>;
  show_ads: Scalars['Boolean']['output'];
  tag: TypeTagResultsData;
  tag_direct: Array<TypeTag>;
  thumbnail: TypeUploadResultsData;
  thumbnail_direct: Array<TypeUploadImage>;
  thumbnail_on_view: Maybe<TypeUploadImage>;
  title: Scalars['String']['output'];
  trailer: TypeUploadResultsData;
  trailer_direct: Array<TypeUploadVideo>;
  trailer_on_view: Maybe<TypeUploadVideo>;
  updated_at: TypeDate;
  updated_at_human: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
  version_uuid: Maybe<Scalars['TypeUUID']['output']>;
  video: TypeUploadResultsData;
  video_direct: Array<TypeUploadVideo>;
  watchable: Scalars['Boolean']['output'];
};


export type TypeMovieActorArgs = {
  body: InputPersonBody;
};


export type TypeMovieAuthorArgs = {
  body: InputUserBody;
};


export type TypeMovieCoverArgs = {
  body: InputUploadBody;
};


export type TypeMovieCreatorArgs = {
  body: InputPersonBody;
};


export type TypeMovieDirectorArgs = {
  body: InputPersonBody;
};


export type TypeMovieGenreArgs = {
  body: InputGenreBody;
};


export type TypeMovieMpaaArgs = {
  body: InputMpaaBody;
};


export type TypeMovieRegionArgs = {
  body: InputRegionBody;
};


export type TypeMovieTagArgs = {
  body: InputTagBody;
};


export type TypeMovieThumbnailArgs = {
  body: InputUploadBody;
};


export type TypeMovieTrailerArgs = {
  body: InputUploadBody;
};


export type TypeMovieVideoArgs = {
  body: InputUploadBody;
};

export type TypeMovieActionResults = {
  __typename?: 'TypeMovieActionResults';
  data: Maybe<TypeMovie>;
};

export type TypeMoviePublishResults = {
  __typename?: 'TypeMoviePublishResults';
  data: Maybe<TypeMovie>;
};

export type TypeMovieRent = {
  __typename?: 'TypeMovieRent';
  expires_in_hours: Scalars['Int']['output'];
};

export type TypeMovieResults = {
  __typename?: 'TypeMovieResults';
  data: Maybe<TypeMovieResultsData>;
};

export type TypeMovieResultsData = {
  __typename?: 'TypeMovieResultsData';
  items: Array<TypeMovie>;
  paging: TypePaging;
};

export type TypeMpaa = {
  __typename?: 'TypeMpaa';
  created_at: TypeDate;
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updated_at: TypeDate;
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeMpaaActionResults = {
  __typename?: 'TypeMpaaActionResults';
  data: Maybe<TypeMpaa>;
};

export type TypeMpaaPublishResults = {
  __typename?: 'TypeMpaaPublishResults';
  data: Maybe<TypeMpaa>;
};

export type TypeMpaaResults = {
  __typename?: 'TypeMpaaResults';
  data: Maybe<TypeMpaaResultsData>;
};

export type TypeMpaaResultsData = {
  __typename?: 'TypeMpaaResultsData';
  items: Array<TypeMpaa>;
  paging: TypePaging;
};

export type TypePageCrossword = {
  __typename?: 'TypePageCrossword';
  pageCrosswordCategory: Maybe<TypePageCrosswordCategory>;
  pageCrosswordCrossword: Maybe<TypePageCrosswordCrossword>;
  pageCrosswordHome: TypePageCrosswordHome;
  pageCrosswordSaved: Maybe<TypePageCrosswordSaved>;
  pageCrosswordSearch: Maybe<TypePageCrosswordSearch>;
  pageCrosswordSeries: Maybe<TypePageCrosswordSeries>;
};


export type TypePageCrosswordPageCrosswordCategoryArgs = {
  body: InputPageCrosswordCategoryParams;
};


export type TypePageCrosswordPageCrosswordCrosswordArgs = {
  body: InputPageCrosswordCrosswordParams;
};


export type TypePageCrosswordPageCrosswordSearchArgs = {
  body: InputPageCrosswordSearchParams;
};


export type TypePageCrosswordPageCrosswordSeriesArgs = {
  body: InputPageCrosswordSeriesParams;
};

export type TypePageCrosswordCategory = {
  __typename?: 'TypePageCrosswordCategory';
  crossword: Array<TypeCrossword>;
  helmet: Maybe<TypeAppHelmet>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type TypePageCrosswordCrossword = {
  __typename?: 'TypePageCrosswordCrossword';
  crossword: Maybe<TypeCrossword>;
  group: Array<TypePageCrosswordCrosswordGroup>;
  helmet: Maybe<TypeAppHelmet>;
  uuid: Scalars['String']['output'];
};

export type TypePageCrosswordCrosswordGroup = {
  __typename?: 'TypePageCrosswordCrosswordGroup';
  items: Array<TypeCrossword>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TypePageCrosswordHome = {
  __typename?: 'TypePageCrosswordHome';
  continue: Array<TypeCrossword>;
  group: Array<TypePageCrosswordHomeGroup>;
  helmet: Maybe<TypeAppHelmet>;
  hero: Maybe<TypeCrossword>;
  saved: Array<TypeCrossword>;
};

export type TypePageCrosswordHomeGroup = {
  __typename?: 'TypePageCrosswordHomeGroup';
  items: Array<TypeCrossword>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TypePageCrosswordResults = {
  __typename?: 'TypePageCrosswordResults';
  data: Maybe<TypePageCrossword>;
};

export type TypePageCrosswordSaved = {
  __typename?: 'TypePageCrosswordSaved';
  completed: Array<TypeCrossword>;
  continue: Array<TypeCrossword>;
  helmet: Maybe<TypeAppHelmet>;
  saved: Array<TypeCrossword>;
  user_uuid: Scalars['TypeUUID']['output'];
};

export type TypePageCrosswordSearch = {
  __typename?: 'TypePageCrosswordSearch';
  crossword: Array<TypeCrossword>;
  helmet: Maybe<TypeAppHelmet>;
  text: Scalars['String']['output'];
};

export type TypePageCrosswordSeries = {
  __typename?: 'TypePageCrosswordSeries';
  crossword: Array<TypeCrossword>;
  helmet: Maybe<TypeAppHelmet>;
  series: Maybe<TypeCrosswordSeries>;
  uuid: Scalars['TypeUUID']['output'];
};

export type TypePageEntry = {
  __typename?: 'TypePageEntry';
  pageEntryPerson: Maybe<TypePageEntryPerson>;
};


export type TypePageEntryPageEntryPersonArgs = {
  body: InputPageEntryPersonParams;
};

export type TypePageEntryPerson = {
  __typename?: 'TypePageEntryPerson';
  crossword: Array<TypeCrossword>;
  helmet: Maybe<TypeAppHelmet>;
  person: TypePerson;
  show: Array<TypeShow>;
  uuid: Scalars['TypeUUID']['output'];
};

export type TypePageEntryResults = {
  __typename?: 'TypePageEntryResults';
  data: Maybe<TypePageEntry>;
};

export type TypePageSc = {
  __typename?: 'TypePageSC';
  businessWorkflows: TypePageScBusinessWorkflows;
  connectAccounts: TypePageScConnectAccounts;
  customerPortal: TypePageScCustomerPortal;
  getStartedConnect: TypePageScGetStartedConnect;
  getStartedPlans: TypePageScGetStartedPlans;
  getStartedSuccess: TypePageScGetStartedSuccess;
  home: TypePageScHome;
  manageConnections: TypePageScManageConnections;
  postWorkflowPublish: TypePageScPostWorkflowPublish;
  postWorkflows: TypePageScPostWorkflows;
  posts: TypePageScPosts;
  workflows: TypePageScWorkflows;
};


export type TypePageScGetStartedPlansArgs = {
  customer_id?: InputMaybe<Scalars['String']['input']>;
};


export type TypePageScPostWorkflowPublishArgs = {
  post_id: Scalars['String']['input'];
};

export type TypePageScBusinessWorkflows = {
  __typename?: 'TypePageSCBusinessWorkflows';
  business: Array<TypeSCBusiness>;
  context: TypeSCUserContext;
  helmet: TypeAppHelmet;
  user_uuid: Scalars['String']['output'];
};

export type TypePageScConnectAccounts = {
  __typename?: 'TypePageSCConnectAccounts';
  context: TypeSCUserContext;
  user_uuid: Scalars['String']['output'];
};

export type TypePageScCustomerPortal = {
  __typename?: 'TypePageSCCustomerPortal';
  context: TypeSCUserContext;
  customer_portal_token: Scalars['String']['output'];
  helmet: TypeAppHelmet;
  user_uuid: Scalars['String']['output'];
};

export type TypePageScGetStartedConnect = {
  __typename?: 'TypePageSCGetStartedConnect';
  context: TypeSCUserContext;
  helmet: TypeAppHelmet;
  user_uuid: Scalars['String']['output'];
};

export type TypePageScGetStartedPlans = {
  __typename?: 'TypePageSCGetStartedPlans';
  context: TypeSCUserContext;
  helmet: TypeAppHelmet;
  user_uuid: Scalars['String']['output'];
};

export type TypePageScGetStartedSuccess = {
  __typename?: 'TypePageSCGetStartedSuccess';
  context: TypeSCUserContext;
  helmet: TypeAppHelmet;
  user_uuid: Scalars['String']['output'];
};

export type TypePageScHome = {
  __typename?: 'TypePageSCHome';
  comments: TypePageScHomeCommentPage;
  context: TypeSCUserContext;
  helmet: TypeAppHelmet;
  user_uuid: Scalars['String']['output'];
};


export type TypePageScHomeCommentsArgs = {
  page: Scalars['Int']['input'];
};

export type TypePageScHomeCommentPage = {
  __typename?: 'TypePageSCHomeCommentPage';
  items: Array<TypeSCApiComment>;
  page: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type TypePageScManageConnections = {
  __typename?: 'TypePageSCManageConnections';
  context: TypeSCUserContext;
  helmet: TypeAppHelmet;
  user_uuid: Scalars['String']['output'];
};

export type TypePageScPostWorkflowPublish = {
  __typename?: 'TypePageSCPostWorkflowPublish';
  context: TypeSCUserContext;
  helmet: TypeAppHelmet;
  post_id: Scalars['String']['output'];
  workflow: TypeSCPostWorkflow;
};

export type TypePageScPostWorkflows = {
  __typename?: 'TypePageSCPostWorkflows';
  context: TypeSCUserContext;
  helmet: TypeAppHelmet;
  user_uuid: Scalars['String']['output'];
  workflow: TypePageScPostWorkflowsPage;
};


export type TypePageScPostWorkflowsWorkflowArgs = {
  page: Scalars['Int']['input'];
  post_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TypePageScPostWorkflowsPage = {
  __typename?: 'TypePageSCPostWorkflowsPage';
  items: Array<TypeSCPostWorkflow>;
  page: Scalars['Int']['output'];
  quantity_per_page: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type TypePageScPosts = {
  __typename?: 'TypePageSCPosts';
  all_posts: TypeSCUserApiPosts;
  context: TypeSCUserContext;
  helmet: TypeAppHelmet;
  user_uuid: Scalars['String']['output'];
};

export type TypePageScResults = {
  __typename?: 'TypePageSCResults';
  data: Maybe<TypePageSc>;
};

export type TypePageScWorkflows = {
  __typename?: 'TypePageSCWorkflows';
  context: TypeSCUserContext;
  helmet: TypeAppHelmet;
  user_uuid: Scalars['String']['output'];
};

export type TypePageShow = {
  __typename?: 'TypePageShow';
  pageShowHome: TypePageShowHome;
  pageShowMovie: Maybe<TypePageShowMovie>;
  pageShowMovies: TypePageShowMovies;
  pageShowPlayer: Maybe<TypePageShowPlayer>;
  pageShowSaved: Maybe<TypePageShowSaved>;
  pageShowSearch: Maybe<TypePageShowSearch>;
  pageShowTv: Maybe<TypePageShowTv>;
  pageShowTvs: TypePageShowTvs;
};


export type TypePageShowPageShowMovieArgs = {
  body: InputPageShowMovieParams;
};


export type TypePageShowPageShowPlayerArgs = {
  body: InputPageShowPlayerParams;
};


export type TypePageShowPageShowSearchArgs = {
  body: InputPageShowSearchParams;
};


export type TypePageShowPageShowTvArgs = {
  body: InputPageShowTvParams;
};

export type TypePageShowHome = {
  __typename?: 'TypePageShowHome';
  continue: Array<TypeShow>;
  group: Array<TypePageShowHomeGroup>;
  helmet: Maybe<TypeAppHelmet>;
  hero: Maybe<TypeShow>;
  saved: Array<TypeShow>;
};

export type TypePageShowHomeGroup = {
  __typename?: 'TypePageShowHomeGroup';
  items: Array<TypeShow>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TypePageShowMovie = {
  __typename?: 'TypePageShowMovie';
  helmet: Maybe<TypeAppHelmet>;
  movie: Maybe<TypeMovie>;
  related: Array<TypeShow>;
  trailer: Maybe<TypePageShowMovieTrailerGroup>;
  uuid: Scalars['String']['output'];
};

export type TypePageShowMovieTrailerGroup = {
  __typename?: 'TypePageShowMovieTrailerGroup';
  items: Array<TypeUploadVideo>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TypePageShowMovies = {
  __typename?: 'TypePageShowMovies';
  continue: Array<TypeShow>;
  group: Array<TypePageShowMoviesGroup>;
  helmet: Maybe<TypeAppHelmet>;
  hero: Maybe<TypeShow>;
  saved: Array<TypeShow>;
};

export type TypePageShowMoviesGroup = {
  __typename?: 'TypePageShowMoviesGroup';
  items: Array<TypeShow>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TypePageShowPlayer = {
  __typename?: 'TypePageShowPlayer';
  episode: Maybe<TypeEpisode>;
  episode_next: Maybe<TypeEpisode>;
  movie: Maybe<TypeMovie>;
  movie_next: Maybe<TypeMovie>;
  uuid: Scalars['String']['output'];
};

export type TypePageShowResults = {
  __typename?: 'TypePageShowResults';
  data: Maybe<TypePageShow>;
};

export type TypePageShowSaved = {
  __typename?: 'TypePageShowSaved';
  helmet: Maybe<TypeAppHelmet>;
  profile_uuid: Scalars['TypeUUID']['output'];
  purchase: Array<TypeShow>;
  rent: Array<TypeShow>;
  saved: Array<TypeShow>;
};

export type TypePageShowSearch = {
  __typename?: 'TypePageShowSearch';
  helmet: Maybe<TypeAppHelmet>;
  show: Array<TypeShow>;
  text: Scalars['String']['output'];
};

export type TypePageShowTv = {
  __typename?: 'TypePageShowTv';
  helmet: Maybe<TypeAppHelmet>;
  related: Array<TypeShow>;
  trailer: Maybe<TypePageShowTvTrailerGroup>;
  tv: Maybe<TypeTv>;
  uuid: Scalars['String']['output'];
};

export type TypePageShowTvTrailerGroup = {
  __typename?: 'TypePageShowTvTrailerGroup';
  items: Array<TypeUploadVideo>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TypePageShowTvs = {
  __typename?: 'TypePageShowTvs';
  continue: Array<TypeShow>;
  group: Array<TypePageShowTvsGroup>;
  helmet: Maybe<TypeAppHelmet>;
  hero: Maybe<TypeShow>;
  saved: Array<TypeShow>;
};

export type TypePageShowTvsGroup = {
  __typename?: 'TypePageShowTvsGroup';
  items: Array<TypeShow>;
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type TypePaging = {
  __typename?: 'TypePaging';
  page: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TypePerson = {
  __typename?: 'TypePerson';
  biography: Maybe<Scalars['String']['output']>;
  birth_date: Maybe<TypeDate>;
  created_at: TypeDate;
  facebook_url: Maybe<Scalars['String']['output']>;
  facebook_user_name: Maybe<Scalars['String']['output']>;
  fallback_image_path: Scalars['String']['output'];
  image: TypeUploadResultsData;
  image_direct: Array<TypeUploadImage>;
  image_on_view: Maybe<TypeUploadImage>;
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  summary: Maybe<Scalars['String']['output']>;
  twitter_url: Maybe<Scalars['String']['output']>;
  twitter_user_name: Maybe<Scalars['String']['output']>;
  updated_at: TypeDate;
  user_name: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
};


export type TypePersonImageArgs = {
  body: InputUploadBody;
};

export type TypePersonActionResults = {
  __typename?: 'TypePersonActionResults';
  data: Maybe<TypePerson>;
};

export type TypePersonPublishResults = {
  __typename?: 'TypePersonPublishResults';
  data: Maybe<TypePerson>;
};

export type TypePersonResults = {
  __typename?: 'TypePersonResults';
  data: Maybe<TypePersonResultsData>;
};

export type TypePersonResultsData = {
  __typename?: 'TypePersonResultsData';
  items: Array<TypePerson>;
  paging: TypePaging;
};

export type TypeProfile = {
  __typename?: 'TypeProfile';
  autoplay_next_episode: Scalars['Boolean']['output'];
  autoplay_preview: Scalars['Boolean']['output'];
  avatar: TypeUploadResultsData;
  avatar_direct: Array<TypeUploadImage>;
  created_at: TypeDate;
  fallback_avatar_path: Scalars['String']['output'];
  is_default: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updated_at: TypeDate;
  user: TypeUser;
  user_uuid: Scalars['TypeUUID']['output'];
  uuid: Scalars['TypeUUID']['output'];
};


export type TypeProfileAvatarArgs = {
  body: InputUploadBody;
};

export type TypeProfileActionResults = {
  __typename?: 'TypeProfileActionResults';
  data: Maybe<TypeProfile>;
};

export type TypeProfileLoginResults = {
  __typename?: 'TypeProfileLoginResults';
  data: Maybe<TypeProfileLoginResultsData>;
};

export type TypeProfileLoginResultsData = {
  __typename?: 'TypeProfileLoginResultsData';
  token: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeProfilePublishResults = {
  __typename?: 'TypeProfilePublishResults';
  data: Maybe<TypeProfile>;
};

export type TypeProfileResults = {
  __typename?: 'TypeProfileResults';
  data: Maybe<TypeProfileResultsData>;
};

export type TypeProfileResultsData = {
  __typename?: 'TypeProfileResultsData';
  items: Array<TypeProfile>;
  paging: TypePaging;
};

export type TypeProfileSaved = {
  __typename?: 'TypeProfileSaved';
  created_at: TypeDate;
  is_archived: Scalars['Boolean']['output'];
  movie: Maybe<TypeMovie>;
  movie_uuid: Maybe<Scalars['TypeUUID']['output']>;
  profile: TypeProfile;
  profile_uuid: Scalars['TypeUUID']['output'];
  tv: Maybe<TypeTv>;
  tv_uuid: Maybe<Scalars['TypeUUID']['output']>;
  updated_at: TypeDate;
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeProfileSavedActionResults = {
  __typename?: 'TypeProfileSavedActionResults';
  data: Maybe<TypeProfileSavedActionResultsData>;
};

export type TypeProfileSavedActionResultsData = {
  __typename?: 'TypeProfileSavedActionResultsData';
  items: Array<TypeProfileSaved>;
};

export type TypeProfileSavedResults = {
  __typename?: 'TypeProfileSavedResults';
  data: Maybe<TypeProfileSavedResultsData>;
};

export type TypeProfileSavedResultsData = {
  __typename?: 'TypeProfileSavedResultsData';
  items: Array<TypeProfileSaved>;
  paging: TypePaging;
};

export type TypeProfileVote = {
  __typename?: 'TypeProfileVote';
  created_at: TypeDate;
  movie: Maybe<TypeMovie>;
  movie_uuid: Maybe<Scalars['TypeUUID']['output']>;
  profile: TypeProfile;
  profile_uuid: Scalars['TypeUUID']['output'];
  tv: Maybe<TypeTv>;
  tv_uuid: Maybe<Scalars['TypeUUID']['output']>;
  updated_at: TypeDate;
  uuid: Scalars['TypeUUID']['output'];
  vote: EnumProfileVoteVote;
};

export type TypeProfileVoteActionResults = {
  __typename?: 'TypeProfileVoteActionResults';
  data: Maybe<TypeProfileVoteActionResultsData>;
};

export type TypeProfileVoteActionResultsData = {
  __typename?: 'TypeProfileVoteActionResultsData';
  items: Array<TypeProfileVote>;
};

export type TypeProfileVoteResults = {
  __typename?: 'TypeProfileVoteResults';
  data: Maybe<TypeProfileVoteResultsData>;
};

export type TypeProfileVoteResultsData = {
  __typename?: 'TypeProfileVoteResultsData';
  items: Array<TypeProfileVote>;
  paging: TypePaging;
};

export type TypeProfileWatchHistory = {
  __typename?: 'TypeProfileWatchHistory';
  created_at: TypeDate;
  episode: Maybe<TypeEpisode>;
  episode_uuid: Maybe<Scalars['TypeUUID']['output']>;
  movie: Maybe<TypeMovie>;
  movie_uuid: Maybe<Scalars['TypeUUID']['output']>;
  profile: TypeProfile;
  profile_uuid: Scalars['TypeUUID']['output'];
  progress: Scalars['Float']['output'];
  updated_at: TypeDate;
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeProfileWatchHistoryActionResults = {
  __typename?: 'TypeProfileWatchHistoryActionResults';
  data: Maybe<TypeProfileWatchHistoryActionResultsData>;
};

export type TypeProfileWatchHistoryActionResultsData = {
  __typename?: 'TypeProfileWatchHistoryActionResultsData';
  items: Array<TypeProfileWatchHistory>;
};

export type TypeProfileWatchHistoryResults = {
  __typename?: 'TypeProfileWatchHistoryResults';
  data: Maybe<TypeProfileWatchHistoryResultsData>;
};

export type TypeProfileWatchHistoryResultsData = {
  __typename?: 'TypeProfileWatchHistoryResultsData';
  items: Array<TypeProfileWatchHistory>;
  paging: TypePaging;
};

export type TypeRegion = {
  __typename?: 'TypeRegion';
  created_at: TypeDate;
  crossword: TypeCrosswordResultsData;
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at: TypeDate;
  uuid: Scalars['TypeUUID']['output'];
};


export type TypeRegionCrosswordArgs = {
  body: InputCrosswordBody;
};

export type TypeRegionActionResults = {
  __typename?: 'TypeRegionActionResults';
  data: Maybe<TypeRegion>;
};

export type TypeRegionPublishResults = {
  __typename?: 'TypeRegionPublishResults';
  data: Maybe<TypeRegion>;
};

export type TypeRegionResults = {
  __typename?: 'TypeRegionResults';
  data: Maybe<TypeRegionResultsData>;
};

export type TypeRegionResultsData = {
  __typename?: 'TypeRegionResultsData';
  items: Array<TypeRegion>;
  paging: TypePaging;
};

export type TypeSCApiComment = {
  __typename?: 'TypeSCApiComment';
  business: TypeSCBusiness;
  business_id: Scalars['String']['output'];
  commenter_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  post: TypeSCApiPost;
  suggested_replies: Array<Scalars['String']['output']>;
  text: Maybe<Scalars['String']['output']>;
  timestamp: TypeDate;
  username: Maybe<Scalars['String']['output']>;
};

export type TypeSCApiPost = {
  __typename?: 'TypeSCApiPost';
  business: TypeSCBusiness;
  business_id: Scalars['String']['output'];
  caption: Maybe<Scalars['String']['output']>;
  fallback_thumbnail_path: Scalars['String']['output'];
  id: Scalars['String']['output'];
  media_url: Maybe<Scalars['String']['output']>;
  permalink: Maybe<Scalars['String']['output']>;
  thumbnail_url: Maybe<Scalars['String']['output']>;
  timestamp: TypeDate;
  username: Scalars['String']['output'];
  workflow: Maybe<TypeSCPostWorkflow>;
};

export type TypeSCBusiness = {
  __typename?: 'TypeSCBusiness';
  fallback_profile_picture_path: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
  permalink: Maybe<Scalars['String']['output']>;
  platform: EnumSCPlatformGql;
  profile_picture_url: Maybe<Scalars['String']['output']>;
  user: TypeUser;
  user_uuid: Scalars['String']['output'];
  username: Maybe<Scalars['String']['output']>;
  workflow: Maybe<TypeSCBusinessWorkflow>;
};

export type TypeSCBusinessActionResults = {
  __typename?: 'TypeSCBusinessActionResults';
  id: Scalars['String']['output'];
};

export type TypeSCBusinessWorkflow = {
  __typename?: 'TypeSCBusinessWorkflow';
  business: TypeSCBusiness;
  business_id: Scalars['String']['output'];
  instructions_text: Scalars['String']['output'];
  reply_as_message: Scalars['Boolean']['output'];
};

export type TypeSCBusinessWorkflowActionResults = {
  __typename?: 'TypeSCBusinessWorkflowActionResults';
  business_id: Scalars['String']['output'];
};

export type TypeSCBusinessWorkflowPublishResults = {
  __typename?: 'TypeSCBusinessWorkflowPublishResults';
  business_id: Scalars['String']['output'];
};

export type TypeSCCommentPublishResults = {
  __typename?: 'TypeSCCommentPublishResults';
  business_comment_uuid: Scalars['String']['output'];
};

export type TypeSCPostWorkflow = {
  __typename?: 'TypeSCPostWorkflow';
  business: TypeSCBusiness;
  business_id: Scalars['String']['output'];
  instructions_text: Scalars['String']['output'];
  post: Maybe<TypeSCApiPost>;
  post_id: Scalars['String']['output'];
  reply_as_message: Scalars['Boolean']['output'];
};

export type TypeSCPostWorkflowActionResults = {
  __typename?: 'TypeSCPostWorkflowActionResults';
  post_id: Scalars['String']['output'];
};

export type TypeSCPostWorkflowPublishResults = {
  __typename?: 'TypeSCPostWorkflowPublishResults';
  post_id: Scalars['String']['output'];
};

export type TypeSCUserApiPosts = {
  __typename?: 'TypeSCUserApiPosts';
  posts: TypeSCUserApiPostsPage;
  user_uuid: Scalars['String']['output'];
};


export type TypeSCUserApiPostsPostsArgs = {
  page: Scalars['Int']['input'];
};

export type TypeSCUserApiPostsPage = {
  __typename?: 'TypeSCUserApiPostsPage';
  items: Array<TypeSCApiPost>;
  page: Scalars['Int']['output'];
  quantity_per_page: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type TypeSCUserContext = {
  __typename?: 'TypeSCUserContext';
  business_level_workflow: Scalars['Boolean']['output'];
  connection: Array<TypeSCBusiness>;
  get_started_completed: Scalars['Boolean']['output'];
  is_subscribed: Scalars['Boolean']['output'];
  max_allowed_connections: Scalars['Int']['output'];
  max_allowed_replies: Scalars['Int']['output'];
  max_allowed_replies_reached: Scalars['Boolean']['output'];
  max_allowed_workflows: Scalars['Int']['output'];
  max_allowed_workflows_reached: Scalars['Boolean']['output'];
  num_suggested_ai_replies: Scalars['Int']['output'];
  post_level_workflow: Scalars['Boolean']['output'];
  pricing_table: TypeSCUserContextPricingTable;
  reply_via_dm: Scalars['Boolean']['output'];
  today_reply_count: Scalars['Int']['output'];
  user: TypeUser;
  user_uuid: Scalars['String']['output'];
  workflow_count: Scalars['Int']['output'];
};

export type TypeSCUserContextPricingTable = {
  __typename?: 'TypeSCUserContextPricingTable';
  session_client_secret: Scalars['String']['output'];
};

export type TypeSaved = {
  __typename?: 'TypeSaved';
  created_at: TypeDate;
  crossword: Maybe<TypeCrossword>;
  crossword_uuid: Maybe<Scalars['TypeUUID']['output']>;
  is_archived: Scalars['Boolean']['output'];
  updated_at: TypeDate;
  user: TypeUser;
  user_uuid: Scalars['TypeUUID']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeSavedActionResults = {
  __typename?: 'TypeSavedActionResults';
  data: Maybe<TypeSavedActionResultsData>;
};

export type TypeSavedActionResultsData = {
  __typename?: 'TypeSavedActionResultsData';
  items: Array<TypeSaved>;
};

export type TypeSavedResults = {
  __typename?: 'TypeSavedResults';
  data: Maybe<TypeSavedResultsData>;
};

export type TypeSavedResultsData = {
  __typename?: 'TypeSavedResultsData';
  items: Array<TypeSaved>;
  paging: TypePaging;
};

export type TypeSeason = {
  __typename?: 'TypeSeason';
  abbreviation: Maybe<TypeEpisodeAbbreviation>;
  actor: TypePersonResultsData;
  actor_direct: Array<TypePerson>;
  admin_title: Maybe<Scalars['String']['output']>;
  author: TypeUserResultsData;
  author_direct: Array<TypeUser>;
  cover: TypeUploadResultsData;
  cover_direct: Array<TypeUploadImage>;
  cover_on_view: Maybe<TypeUploadImage>;
  created_at: TypeDate;
  created_at_human: Scalars['String']['output'];
  creator: TypePersonResultsData;
  creator_direct: Array<TypePerson>;
  director: TypePersonResultsData;
  director_direct: Array<TypePerson>;
  episode: TypeEpisodeResultsData;
  episode_watchable: Array<TypeEpisode>;
  fallback_cover_path: Scalars['String']['output'];
  fallback_thumbnail_path: Scalars['String']['output'];
  free_for_subscriber: Scalars['Boolean']['output'];
  has_premiered: Scalars['Boolean']['output'];
  is_active: Scalars['Boolean']['output'];
  is_banned: Scalars['Boolean']['output'];
  is_published: Scalars['Boolean']['output'];
  is_trashed: Scalars['Boolean']['output'];
  long_description: Maybe<Scalars['String']['output']>;
  number: Maybe<Scalars['Int']['output']>;
  play: Maybe<TypeEpisode>;
  premier_date: TypeDate;
  premier_date_human: Scalars['String']['output'];
  purchasable: Scalars['Boolean']['output'];
  purchase_price: Scalars['Float']['output'];
  purchase_price_default: Scalars['Float']['output'];
  purchase_price_us: Maybe<Scalars['Float']['output']>;
  purchased: Maybe<Scalars['Boolean']['output']>;
  rent_price: Scalars['Float']['output'];
  rent_price_default: Scalars['Float']['output'];
  rent_price_us: Maybe<Scalars['Float']['output']>;
  rentable: Scalars['Boolean']['output'];
  rented: Maybe<TypeSeasonRent>;
  resume: Maybe<TypeEpisode>;
  short_description: Maybe<Scalars['String']['output']>;
  show_ads: Scalars['Boolean']['output'];
  thumbnail: TypeUploadResultsData;
  thumbnail_direct: Array<TypeUploadImage>;
  thumbnail_on_view: Maybe<TypeUploadImage>;
  title: Scalars['String']['output'];
  trailer: TypeUploadResultsData;
  trailer_direct: Array<TypeUploadVideo>;
  trailer_on_view: Maybe<TypeUploadVideo>;
  tv: TypeTvResultsData;
  tv_watchable: Maybe<TypeTv>;
  updated_at: TypeDate;
  updated_at_human: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
  version_uuid: Maybe<Scalars['TypeUUID']['output']>;
  watchable: Scalars['Boolean']['output'];
};


export type TypeSeasonActorArgs = {
  body: InputPersonBody;
};


export type TypeSeasonAuthorArgs = {
  body: InputUserBody;
};


export type TypeSeasonCoverArgs = {
  body: InputUploadBody;
};


export type TypeSeasonCreatorArgs = {
  body: InputPersonBody;
};


export type TypeSeasonDirectorArgs = {
  body: InputPersonBody;
};


export type TypeSeasonEpisodeArgs = {
  body: InputEpisodeBody;
};


export type TypeSeasonThumbnailArgs = {
  body: InputUploadBody;
};


export type TypeSeasonTrailerArgs = {
  body: InputUploadBody;
};


export type TypeSeasonTvArgs = {
  body: InputTvBody;
};

export type TypeSeasonAbbreviation = {
  __typename?: 'TypeSeasonAbbreviation';
  long: Scalars['String']['output'];
  short: Scalars['String']['output'];
};

export type TypeSeasonActionResults = {
  __typename?: 'TypeSeasonActionResults';
  data: Maybe<TypeSeason>;
};

export type TypeSeasonPublishResults = {
  __typename?: 'TypeSeasonPublishResults';
  data: Maybe<TypeSeason>;
};

export type TypeSeasonRent = {
  __typename?: 'TypeSeasonRent';
  expires_in_hours: Scalars['Int']['output'];
};

export type TypeSeasonResults = {
  __typename?: 'TypeSeasonResults';
  data: Maybe<TypeSeasonResultsData>;
};

export type TypeSeasonResultsData = {
  __typename?: 'TypeSeasonResultsData';
  items: Array<TypeSeason>;
  paging: TypePaging;
};

export type TypeSendConfirmEmailLinkResults = {
  __typename?: 'TypeSendConfirmEmailLinkResults';
  data: Maybe<TypeSendConfirmEmailLinkResultsData>;
};

export type TypeSendConfirmEmailLinkResultsData = {
  __typename?: 'TypeSendConfirmEmailLinkResultsData';
  user: TypeUser;
};

export type TypeSendLoginCodeResults = {
  __typename?: 'TypeSendLoginCodeResults';
  message: Scalars['String']['output'];
};

export type TypeSendPasswordResetLinkResults = {
  __typename?: 'TypeSendPasswordResetLinkResults';
  data: Maybe<TypeSendPasswordResetLinkResultsData>;
};

export type TypeSendPasswordResetLinkResultsData = {
  __typename?: 'TypeSendPasswordResetLinkResultsData';
  status: Scalars['Boolean']['output'];
};

export type TypeSetting = {
  __typename?: 'TypeSetting';
  ads: Scalars['Boolean']['output'];
  ads_adsense: Scalars['Boolean']['output'];
  created_at: TypeDate;
  updated_at: TypeDate;
  user_approved_by_default: Scalars['Boolean']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeSettingPublishResults = {
  __typename?: 'TypeSettingPublishResults';
  data: Maybe<TypeSetting>;
};

export type TypeSettingResults = {
  __typename?: 'TypeSettingResults';
  data: Maybe<TypeSettingResultsData>;
};

export type TypeSettingResultsData = {
  __typename?: 'TypeSettingResultsData';
  items: Array<TypeSetting>;
  paging: TypePaging;
};

export type TypeShow = {
  __typename?: 'TypeShow';
  episode: Maybe<TypeEpisode>;
  is_episode: Scalars['Boolean']['output'];
  is_movie: Scalars['Boolean']['output'];
  is_season: Scalars['Boolean']['output'];
  is_series: Scalars['Boolean']['output'];
  is_tv: Scalars['Boolean']['output'];
  movie: Maybe<TypeMovie>;
  season: Maybe<TypeSeason>;
  series: Maybe<TypeShowSeries>;
  tv: Maybe<TypeTv>;
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeShowResults = {
  __typename?: 'TypeShowResults';
  data: Maybe<TypeShowResultsData>;
};

export type TypeShowResultsData = {
  __typename?: 'TypeShowResultsData';
  items: Array<TypeShow>;
  paging: TypePaging;
};

export type TypeShowSeries = {
  __typename?: 'TypeShowSeries';
  created_at: TypeDate;
  description: Maybe<Scalars['String']['output']>;
  description_rich: Maybe<Scalars['String']['output']>;
  end_time: TypeDate;
  fallback_image_path: Scalars['String']['output'];
  has_ended: Scalars['Boolean']['output'];
  has_started: Scalars['Boolean']['output'];
  image: TypeUploadResultsData;
  image_direct: Array<TypeUploadImage>;
  image_on_view: Maybe<TypeUploadImage>;
  is_active: Scalars['Boolean']['output'];
  is_published: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  show: TypeShowSeriesShowResultsData;
  slug: Scalars['String']['output'];
  start_time: TypeDate;
  type: Scalars['String']['output'];
  updated_at: TypeDate;
  user: Maybe<TypeUser>;
  user_uuid: Maybe<Scalars['TypeUUID']['output']>;
  uuid: Scalars['TypeUUID']['output'];
};


export type TypeShowSeriesImageArgs = {
  body: InputUploadBody;
};


export type TypeShowSeriesShowArgs = {
  body: InputShowBody;
  sequence_sort?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TypeShowSeriesActionResults = {
  __typename?: 'TypeShowSeriesActionResults';
  data: Maybe<TypeShowSeries>;
};

export type TypeShowSeriesPublishResults = {
  __typename?: 'TypeShowSeriesPublishResults';
  data: Maybe<TypeShowSeries>;
};

export type TypeShowSeriesResults = {
  __typename?: 'TypeShowSeriesResults';
  data: Maybe<TypeShowSeriesResultsData>;
};

export type TypeShowSeriesResultsData = {
  __typename?: 'TypeShowSeriesResultsData';
  items: Array<TypeShowSeries>;
  paging: TypePaging;
};

export type TypeShowSeriesShowResultsData = {
  __typename?: 'TypeShowSeriesShowResultsData';
  items: Array<TypeShow>;
};

export type TypeSignedUrlForUploadResults = {
  __typename?: 'TypeSignedUrlForUploadResults';
  data: Maybe<TypeSignedUrlForUploadResultsData>;
};

export type TypeSignedUrlForUploadResultsData = {
  __typename?: 'TypeSignedUrlForUploadResultsData';
  upload_url: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type TypeTag = {
  __typename?: 'TypeTag';
  created_at: TypeDate;
  crossword: TypeCrosswordResultsData;
  description: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updated_at: TypeDate;
  uuid: Scalars['TypeUUID']['output'];
};


export type TypeTagCrosswordArgs = {
  body: InputCrosswordBody;
};

export type TypeTagActionResults = {
  __typename?: 'TypeTagActionResults';
  data: Maybe<TypeTag>;
};

export type TypeTagPublishResults = {
  __typename?: 'TypeTagPublishResults';
  data: Maybe<TypeTag>;
};

export type TypeTagResults = {
  __typename?: 'TypeTagResults';
  data: Maybe<TypeTagResultsData>;
};

export type TypeTagResultsData = {
  __typename?: 'TypeTagResultsData';
  items: Array<TypeTag>;
  paging: TypePaging;
};

export type TypeTv = {
  __typename?: 'TypeTv';
  actor: TypePersonResultsData;
  actor_direct: Array<TypePerson>;
  admin_title: Maybe<Scalars['String']['output']>;
  author: TypeUserResultsData;
  author_direct: Array<TypeUser>;
  cover: TypeUploadResultsData;
  cover_direct: Array<TypeUploadImage>;
  cover_on_view: Maybe<TypeUploadImage>;
  created_at: TypeDate;
  created_at_human: Scalars['String']['output'];
  creator: TypePersonResultsData;
  creator_direct: Array<TypePerson>;
  director: TypePersonResultsData;
  director_direct: Array<TypePerson>;
  fallback_cover_path: Scalars['String']['output'];
  fallback_thumbnail_path: Scalars['String']['output'];
  free_for_subscriber: Scalars['Boolean']['output'];
  genre: TypeGenreResultsData;
  genre_direct: Array<TypeGenre>;
  has_premiered: Scalars['Boolean']['output'];
  is_active: Scalars['Boolean']['output'];
  is_banned: Scalars['Boolean']['output'];
  is_published: Scalars['Boolean']['output'];
  is_trashed: Scalars['Boolean']['output'];
  long_description: Maybe<Scalars['String']['output']>;
  mpaa: TypeMpaaResultsData;
  mpaa_direct: Array<TypeMpaa>;
  owner_user: Maybe<TypeUser>;
  owner_user_uuid: Maybe<Scalars['TypeUUID']['output']>;
  path: Scalars['String']['output'];
  play: Maybe<TypeEpisode>;
  premier_date: TypeDate;
  premier_date_human: Scalars['String']['output'];
  purchasable: Scalars['Boolean']['output'];
  purchase_commission_percent: Scalars['Int']['output'];
  purchase_price: Scalars['Float']['output'];
  purchase_price_default: Scalars['Float']['output'];
  purchase_price_us: Maybe<Scalars['Float']['output']>;
  purchased: Maybe<Scalars['Boolean']['output']>;
  region: TypeRegionResultsData;
  region_direct: Array<TypeRegion>;
  rent_commission_percent: Scalars['Int']['output'];
  rent_price: Scalars['Float']['output'];
  rent_price_default: Scalars['Float']['output'];
  rent_price_us: Maybe<Scalars['Float']['output']>;
  rentable: Scalars['Boolean']['output'];
  rented: Maybe<TypeTvRent>;
  resume: Maybe<TypeEpisode>;
  search_token: Maybe<Scalars['String']['output']>;
  season: TypeSeasonResultsData;
  season_watchable: Array<TypeSeason>;
  short_description: Maybe<Scalars['String']['output']>;
  show_ads: Scalars['Boolean']['output'];
  tag: TypeTagResultsData;
  tag_direct: Array<TypeTag>;
  thumbnail: TypeUploadResultsData;
  thumbnail_direct: Array<TypeUploadImage>;
  thumbnail_on_view: Maybe<TypeUploadImage>;
  title: Scalars['String']['output'];
  trailer: TypeUploadResultsData;
  trailer_direct: Array<TypeUploadVideo>;
  trailer_on_view: Maybe<TypeUploadVideo>;
  updated_at: TypeDate;
  updated_at_human: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
  version_uuid: Maybe<Scalars['TypeUUID']['output']>;
  watchable: Scalars['Boolean']['output'];
};


export type TypeTvActorArgs = {
  body: InputPersonBody;
};


export type TypeTvAuthorArgs = {
  body: InputUserBody;
};


export type TypeTvCoverArgs = {
  body: InputUploadBody;
};


export type TypeTvCreatorArgs = {
  body: InputPersonBody;
};


export type TypeTvDirectorArgs = {
  body: InputPersonBody;
};


export type TypeTvGenreArgs = {
  body: InputGenreBody;
};


export type TypeTvMpaaArgs = {
  body: InputMpaaBody;
};


export type TypeTvRegionArgs = {
  body: InputRegionBody;
};


export type TypeTvSeasonArgs = {
  body: InputSeasonBody;
};


export type TypeTvTagArgs = {
  body: InputTagBody;
};


export type TypeTvThumbnailArgs = {
  body: InputUploadBody;
};


export type TypeTvTrailerArgs = {
  body: InputUploadBody;
};

export type TypeTvActionResults = {
  __typename?: 'TypeTvActionResults';
  data: Maybe<TypeTv>;
};

export type TypeTvPublishResults = {
  __typename?: 'TypeTvPublishResults';
  data: Maybe<TypeTv>;
};

export type TypeTvRent = {
  __typename?: 'TypeTvRent';
  expires_in_hours: Scalars['Int']['output'];
};

export type TypeTvResults = {
  __typename?: 'TypeTvResults';
  data: Maybe<TypeTvResultsData>;
};

export type TypeTvResultsData = {
  __typename?: 'TypeTvResultsData';
  items: Array<TypeTv>;
  paging: TypePaging;
};

export type TypeUpload = {
  __typename?: 'TypeUpload';
  content_type: Maybe<Scalars['String']['output']>;
  created_at: TypeDate;
  description: Scalars['String']['output'];
  google_storage_key: Maybe<Scalars['String']['output']>;
  image: Maybe<TypeUploadImage>;
  is_public: Maybe<Scalars['Boolean']['output']>;
  language: TypeLanguageResultsData;
  name: Scalars['String']['output'];
  sequence: Maybe<Scalars['Int']['output']>;
  type: Maybe<Scalars['String']['output']>;
  user: Maybe<TypeUser>;
  user_uuid: Maybe<Scalars['String']['output']>;
  uuid: Scalars['TypeUUID']['output'];
  video: Maybe<TypeUploadVideo>;
};


export type TypeUploadLanguageArgs = {
  body: InputLanguageBody;
};

export type TypeUploadActionResults = {
  __typename?: 'TypeUploadActionResults';
  data: Maybe<TypeUpload>;
};

export type TypeUploadImage = {
  __typename?: 'TypeUploadImage';
  is_avatar: Scalars['Boolean']['output'];
  path: Scalars['String']['output'];
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeUploadPublishResults = {
  __typename?: 'TypeUploadPublishResults';
  data: Maybe<TypeUpload>;
};

export type TypeUploadResults = {
  __typename?: 'TypeUploadResults';
  data: Maybe<TypeUploadResultsData>;
};

export type TypeUploadResultsData = {
  __typename?: 'TypeUploadResultsData';
  items: Array<TypeUpload>;
  paging: TypePaging;
};

export type TypeUploadVideo = {
  __typename?: 'TypeUploadVideo';
  duration_seconds: Maybe<Scalars['Int']['output']>;
  mp4_low_url: Maybe<Scalars['String']['output']>;
  mux_asset_environment: Maybe<Scalars['String']['output']>;
  mux_asset_id: Maybe<Scalars['String']['output']>;
  mux_playback_id: Maybe<Scalars['String']['output']>;
  playback_token: Maybe<Scalars['String']['output']>;
  thumbnail_path: Scalars['String']['output'];
  thumbnail_token: Maybe<Scalars['String']['output']>;
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeUser = {
  __typename?: 'TypeUser';
  biography: Maybe<Scalars['String']['output']>;
  birth_date: Maybe<TypeDate>;
  coins: Scalars['Int']['output'];
  created_at: TypeDate;
  creditVoucherOwnerAnalytics: TypeCreditVoucherMultipleStatistics;
  credits: Scalars['Float']['output'];
  crossword: TypeCrosswordResultsData;
  crossword_completed: Scalars['Int']['output'];
  crossword_score: Scalars['Int']['output'];
  crossword_solution: TypeCrosswordSolutionResultsData;
  domain_env: EnumDomainEnvGql;
  email: Maybe<Scalars['String']['output']>;
  email_is_confirmed: Scalars['Boolean']['output'];
  facebook_url: Maybe<Scalars['String']['output']>;
  facebook_user_name: Maybe<Scalars['String']['output']>;
  image: TypeUploadResultsData;
  is_approved: Scalars['Boolean']['output'];
  is_banned: Scalars['Boolean']['output'];
  name: Maybe<Scalars['String']['output']>;
  permission_roles: Array<Scalars['String']['output']>;
  phone_number: Maybe<Scalars['String']['output']>;
  profile: TypeProfileResultsData;
  saved: TypeSavedResultsData;
  sc_user_context: TypeSCUserContext;
  summary: Maybe<Scalars['String']['output']>;
  twitter_url: Maybe<Scalars['String']['output']>;
  twitter_user_name: Maybe<Scalars['String']['output']>;
  updated_at: TypeDate;
  user_name: Maybe<Scalars['String']['output']>;
  uuid: Scalars['TypeUUID']['output'];
};


export type TypeUserCreditVoucherOwnerAnalyticsArgs = {
  body: InputCreditVoucherFindParams;
};


export type TypeUserCrosswordArgs = {
  body: InputCrosswordBody;
};


export type TypeUserCrosswordSolutionArgs = {
  body: InputCrosswordSolutionBody;
};


export type TypeUserImageArgs = {
  body: InputUploadBody;
};


export type TypeUserProfileArgs = {
  body: InputProfileBody;
};


export type TypeUserSavedArgs = {
  body: InputSavedBody;
};

export type TypeUserActionResults = {
  __typename?: 'TypeUserActionResults';
  data: Maybe<TypeUser>;
};

export type TypeUserPublishResults = {
  __typename?: 'TypeUserPublishResults';
  data: Maybe<TypeUser>;
};

export type TypeUserPublishSudoResults = {
  __typename?: 'TypeUserPublishSudoResults';
  data: Maybe<TypeUser>;
};

export type TypeUserResults = {
  __typename?: 'TypeUserResults';
  data: Maybe<TypeUserResultsData>;
};

export type TypeUserResultsData = {
  __typename?: 'TypeUserResultsData';
  items: Array<TypeUser>;
  paging: TypePaging;
};

export type TypeUserShowPurchase = {
  __typename?: 'TypeUserShowPurchase';
  commission_percent: Scalars['Int']['output'];
  country_code: Maybe<Scalars['String']['output']>;
  created_at: TypeDate;
  owner_user: Maybe<TypeUser>;
  owner_user_uuid: Maybe<Scalars['TypeUUID']['output']>;
  price: Scalars['Float']['output'];
  show: Maybe<TypeShow>;
  updated_at: TypeDate;
  user: Maybe<TypeUser>;
  user_uuid: Maybe<Scalars['TypeUUID']['output']>;
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeUserShowPurchaseActionResults = {
  __typename?: 'TypeUserShowPurchaseActionResults';
  data: Maybe<TypeUserShowPurchase>;
};

export type TypeUserShowPurchasePublishResults = {
  __typename?: 'TypeUserShowPurchasePublishResults';
  data: Maybe<TypeUserShowPurchase>;
};

export type TypeUserShowPurchaseResults = {
  __typename?: 'TypeUserShowPurchaseResults';
  data: Maybe<TypeUserShowPurchaseResultsData>;
};

export type TypeUserShowPurchaseResultsData = {
  __typename?: 'TypeUserShowPurchaseResultsData';
  items: Array<TypeUserShowPurchase>;
  paging: TypePaging;
};

export type TypeUserShowPurchaseStatistics = {
  __typename?: 'TypeUserShowPurchaseStatistics';
  commission_revenue: Scalars['Float']['output'];
  num_purchases: Scalars['Int']['output'];
  owner_net_income: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  version: Scalars['Int']['output'];
};


export type TypeUserShowPurchaseStatisticsCommissionRevenueArgs = {
  body: InputUserShowPurchaseBody;
};


export type TypeUserShowPurchaseStatisticsNumPurchasesArgs = {
  body: InputUserShowPurchaseBody;
};


export type TypeUserShowPurchaseStatisticsOwnerNetIncomeArgs = {
  body: InputUserShowPurchaseBody;
};


export type TypeUserShowPurchaseStatisticsRevenueArgs = {
  body: InputUserShowPurchaseBody;
};

export type TypeUserShowPurchaseStatisticsResults = {
  __typename?: 'TypeUserShowPurchaseStatisticsResults';
  data: TypeUserShowPurchaseStatistics;
};

export type TypeUserShowRent = {
  __typename?: 'TypeUserShowRent';
  commission_percent: Scalars['Int']['output'];
  country_code: Maybe<Scalars['String']['output']>;
  created_at: TypeDate;
  expires_in_hours: Scalars['Int']['output'];
  is_active: Scalars['Boolean']['output'];
  owner_user: Maybe<TypeUser>;
  owner_user_uuid: Maybe<Scalars['TypeUUID']['output']>;
  price: Scalars['Float']['output'];
  show: Maybe<TypeShow>;
  updated_at: TypeDate;
  user: Maybe<TypeUser>;
  user_uuid: Maybe<Scalars['TypeUUID']['output']>;
  uuid: Scalars['TypeUUID']['output'];
};

export type TypeUserShowRentActionResults = {
  __typename?: 'TypeUserShowRentActionResults';
  data: Maybe<TypeUserShowRent>;
};

export type TypeUserShowRentPublishResults = {
  __typename?: 'TypeUserShowRentPublishResults';
  data: Maybe<TypeUserShowRent>;
};

export type TypeUserShowRentResults = {
  __typename?: 'TypeUserShowRentResults';
  data: Maybe<TypeUserShowRentResultsData>;
};

export type TypeUserShowRentResultsData = {
  __typename?: 'TypeUserShowRentResultsData';
  items: Array<TypeUserShowRent>;
  paging: TypePaging;
};

export type TypeUserShowRentStatistics = {
  __typename?: 'TypeUserShowRentStatistics';
  commission_revenue: Scalars['Float']['output'];
  num_rents: Scalars['Int']['output'];
  owner_net_income: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  version: Scalars['Int']['output'];
};


export type TypeUserShowRentStatisticsCommissionRevenueArgs = {
  body: InputUserShowRentBody;
};


export type TypeUserShowRentStatisticsNumRentsArgs = {
  body: InputUserShowRentBody;
};


export type TypeUserShowRentStatisticsOwnerNetIncomeArgs = {
  body: InputUserShowRentBody;
};


export type TypeUserShowRentStatisticsRevenueArgs = {
  body: InputUserShowRentBody;
};

export type TypeUserShowRentStatisticsResults = {
  __typename?: 'TypeUserShowRentStatisticsResults';
  data: TypeUserShowRentStatistics;
};

export type HooksApplyCreditVoucherMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type HooksApplyCreditVoucherMutation = { __typename?: 'Mutation', applyCreditVoucher: { __typename?: 'TypeApplyCreditVoucherResults', data: { __typename?: 'TypeApplyCreditVoucherResultsData', status: boolean } | null } };

export type HooksConfirmEmailMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type HooksConfirmEmailMutation = { __typename?: 'Mutation', accountConfirmEmail: { __typename?: 'TypeAccountConfirmEmailResults', data: { __typename?: 'TypeAccountConfirmEmailResultsData', status: boolean } | null } };

export type HooksAccountCreateMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  confirm_password: Scalars['String']['input'];
}>;


export type HooksAccountCreateMutation = { __typename?: 'Mutation', accountCreate: { __typename?: 'TypeAccountCreateResults', data: { __typename?: 'TypeAccountCreateResultsData', uuid: TypeUUID, token: string } | null } };

export type HooksAccountForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type HooksAccountForgotPasswordMutation = { __typename?: 'Mutation', sendPasswordResetLink: { __typename?: 'TypeSendPasswordResetLinkResults', data: { __typename?: 'TypeSendPasswordResetLinkResultsData', status: boolean } | null } };

export type HooksAccountLoginAppleMutationVariables = Exact<{
  body: InputAccountLoginAppleBody;
}>;


export type HooksAccountLoginAppleMutation = { __typename?: 'Mutation', accountLoginApple: { __typename?: 'TypeAccountLoginAppleResults', data: { __typename?: 'TypeAccountLoginAppleResultsData', uuid: TypeUUID, token: string } | null } };

export type HooksLoginAuthCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type HooksLoginAuthCodeMutation = { __typename?: 'Mutation', loginAuthCode: { __typename?: 'TypeLoginAuthCodeResults', data: { __typename?: 'TypeLoginAuthCodeResultsData', status: boolean } | null } };

export type HooksAccountLoginCodeMutationVariables = Exact<{
  body: InputAccountLoginCodeBody;
}>;


export type HooksAccountLoginCodeMutation = { __typename?: 'Mutation', accountLoginCode: { __typename?: 'TypeAccountLoginCodeResults', data: { __typename?: 'TypeAccountLoginCodeResultsData', uuid: TypeUUID, token: string } | null } };

export type HooksAccountLoginFacebookMutationVariables = Exact<{
  body: InputAccountLoginFacebookBody;
}>;


export type HooksAccountLoginFacebookMutation = { __typename?: 'Mutation', accountLoginFacebook: { __typename?: 'TypeAccountLoginFacebookResults', data: { __typename?: 'TypeAccountLoginFacebookResultsData', uuid: TypeUUID, token: string } | null } };

export type HooksAccountLoginGoogleMutationVariables = Exact<{
  body: InputAccountLoginGoogleBody;
}>;


export type HooksAccountLoginGoogleMutation = { __typename?: 'Mutation', accountLoginGoogle: { __typename?: 'TypeAccountLoginGoogleResults', data: { __typename?: 'TypeAccountLoginGoogleResultsData', uuid: TypeUUID, token: string } | null } };

export type HooksAccountLoginMutationVariables = Exact<{
  user_name: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type HooksAccountLoginMutation = { __typename?: 'Mutation', accountLogin: { __typename?: 'TypeAccountLoginResults', data: { __typename?: 'TypeAccountLoginResultsData', uuid: TypeUUID, token: string } | null } };

export type HooksAccountLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type HooksAccountLogoutMutation = { __typename?: 'Mutation', accountLogout: { __typename?: 'TypeAccountLogoutResults', data: { __typename?: 'TypeAccountLogoutResultsData', status: boolean } | null } };

export type HooksAccountResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
  confirm_password: Scalars['String']['input'];
}>;


export type HooksAccountResetPasswordMutation = { __typename?: 'Mutation', accountResetPassword: { __typename?: 'TypeAccountResetPasswordResults', data: { __typename?: 'TypeAccountResetPasswordResultsData', uuid: TypeUUID, token: string } | null } };

export type HooksSendLoginCodeMutationVariables = Exact<{
  body: InputSendLoginCodeBody;
}>;


export type HooksSendLoginCodeMutation = { __typename?: 'Mutation', sendLoginCode: { __typename?: 'TypeSendLoginCodeResults', message: string } };

export type PageEntryPersonQueryVariables = Exact<{
  user_name: Scalars['String']['input'];
}>;


export type PageEntryPersonQuery = { __typename?: 'Query', pageEntry: { __typename?: 'TypePageEntryResults', data: { __typename?: 'TypePageEntry', pageEntryPerson: { __typename?: 'TypePageEntryPerson', uuid: TypeUUID, person: { __typename?: 'TypePerson', uuid: TypeUUID, name: string, summary: string | null, biography: string | null, path: string, fallback_image_path: string, image_on_view: { __typename?: 'TypeUploadImage', uuid: TypeUUID, path: string } | null }, show: Array<{ __typename?: 'TypeShow', uuid: TypeUUID, movie: { __typename?: 'TypeMovie', uuid: TypeUUID, title: string, path: string, fallback_cover_path: string, cover_on_view: { __typename?: 'TypeUploadImage', uuid: TypeUUID, path: string } | null } | null, tv: { __typename?: 'TypeTv', uuid: TypeUUID, title: string, path: string, fallback_cover_path: string, cover_on_view: { __typename?: 'TypeUploadImage', uuid: TypeUUID, path: string } | null } | null }>, crossword: Array<{ __typename?: 'TypeCrossword', uuid: TypeUUID, title: string, number: number, path: string, fallback_image_path: string, image_on_view: { __typename?: 'TypeUploadImage', uuid: TypeUUID, path: string } | null }>, helmet: { __typename?: 'TypeAppHelmet', title: string, description: string, canonical_url: string, jsonld: string | null, disable_google_index: boolean | null, image: { __typename?: 'TypeAppHelmetImage', url: string, thumbnail_url: string | null, dimensions: { __typename?: 'TypeAppHelmetImageDimensions', width: number, height: number } | null } | null, video_mp4: { __typename?: 'TypeAppHelmetVideoMp4', url: string } | null, published_time: { __typename?: 'TypeDate', iso: TypeDateIso } | null, modified_time: { __typename?: 'TypeDate', iso: TypeDateIso } | null } | null } | null } | null } };

export type FragmentPageEntryPersonFragment = { __typename?: 'TypePerson', uuid: TypeUUID, name: string, summary: string | null, biography: string | null, path: string, fallback_image_path: string, image_on_view: { __typename?: 'TypeUploadImage', uuid: TypeUUID, path: string } | null };

export type FragmentAppHelmetFragment = { __typename?: 'TypeAppHelmet', title: string, description: string, canonical_url: string, jsonld: string | null, disable_google_index: boolean | null, image: { __typename?: 'TypeAppHelmetImage', url: string, thumbnail_url: string | null, dimensions: { __typename?: 'TypeAppHelmetImageDimensions', width: number, height: number } | null } | null, video_mp4: { __typename?: 'TypeAppHelmetVideoMp4', url: string } | null, published_time: { __typename?: 'TypeDate', iso: TypeDateIso } | null, modified_time: { __typename?: 'TypeDate', iso: TypeDateIso } | null };

export type GetUploadsQueryVariables = Exact<{
  uuids: Array<Scalars['TypeUUID']['input']> | Scalars['TypeUUID']['input'];
}>;


export type GetUploadsQuery = { __typename?: 'Query', uploadsByUUID: Array<{ __typename?: 'TypeUpload', uuid: TypeUUID, name: string, description: string, image: { __typename?: 'TypeUploadImage', uuid: TypeUUID, path: string } | null, video: { __typename?: 'TypeUploadVideo', uuid: TypeUUID, thumbnail_path: string } | null } | null> };

export type FragmentGetUploadsUploadFragment = { __typename?: 'TypeUpload', uuid: TypeUUID, name: string, description: string, image: { __typename?: 'TypeUploadImage', uuid: TypeUUID, path: string } | null, video: { __typename?: 'TypeUploadVideo', uuid: TypeUUID, thumbnail_path: string } | null };

export type FragmentPageDataViewerFragment = { __typename?: 'TypeUser', uuid: TypeUUID, name: string | null, user_name: string | null, email: string | null, email_is_confirmed: boolean, phone_number: string | null, permission_roles: Array<string>, is_banned: boolean, is_approved: boolean, credits: number, coins: number, created_at: { __typename?: 'TypeDate', iso: TypeDateIso }, sc_user_context: { __typename?: 'TypeSCUserContext', user_uuid: string, get_started_completed: boolean, is_subscribed: boolean, connection: Array<{ __typename?: 'TypeSCBusiness', id: string }> } };

export type FragmentPageDataProfileFragment = { __typename?: 'TypeProfile', uuid: TypeUUID, user_uuid: TypeUUID, name: string, is_default: boolean, autoplay_next_episode: boolean, autoplay_preview: boolean, fallback_avatar_path: string, avatar_direct: Array<{ __typename?: 'TypeUploadImage', uuid: TypeUUID, path: string }> };

export type HooksPageDataQueryVariables = Exact<{ [key: string]: never; }>;


export type HooksPageDataQuery = { __typename?: 'Query', viewer: { __typename?: 'TypeUser', uuid: TypeUUID, name: string | null, user_name: string | null, email: string | null, email_is_confirmed: boolean, phone_number: string | null, permission_roles: Array<string>, is_banned: boolean, is_approved: boolean, credits: number, coins: number, created_at: { __typename?: 'TypeDate', iso: TypeDateIso }, sc_user_context: { __typename?: 'TypeSCUserContext', user_uuid: string, get_started_completed: boolean, is_subscribed: boolean, connection: Array<{ __typename?: 'TypeSCBusiness', id: string }> } } | null, viewerProfile: { __typename?: 'TypeProfile', uuid: TypeUUID, user_uuid: TypeUUID, name: string, is_default: boolean, autoplay_next_episode: boolean, autoplay_preview: boolean, fallback_avatar_path: string, avatar_direct: Array<{ __typename?: 'TypeUploadImage', uuid: TypeUUID, path: string }> } | null, viewerProfiles: Array<{ __typename?: 'TypeProfile', uuid: TypeUUID, user_uuid: TypeUUID, name: string, is_default: boolean, autoplay_next_episode: boolean, autoplay_preview: boolean, fallback_avatar_path: string, avatar_direct: Array<{ __typename?: 'TypeUploadImage', uuid: TypeUUID, path: string }> }> };

export type FragmentPageDataCountryFragment = { __typename?: 'TypeCountry', code: string, dial_code: string, name: string, is_united_states: boolean, is_tanzania: boolean };

export type HooksPageDataCountryQueryVariables = Exact<{ [key: string]: never; }>;


export type HooksPageDataCountryQuery = { __typename?: 'Query', country: { __typename?: 'TypeCountry', code: string, dial_code: string, name: string, is_united_states: boolean, is_tanzania: boolean } | null };

export type FragmentPageDataCurrencyFragment = { __typename?: 'TypeCurrencyResultsData', usd_tzs: number };

export type HooksPageDataCurrencyQueryVariables = Exact<{ [key: string]: never; }>;


export type HooksPageDataCurrencyQuery = { __typename?: 'Query', currency: { __typename?: 'TypeCurrencyResults', data: { __typename?: 'TypeCurrencyResultsData', usd_tzs: number } | null } };

export type HooksCreateSignedUrlForUploadMutationVariables = Exact<{
  body: InputSignedUrlForUpload;
}>;


export type HooksCreateSignedUrlForUploadMutation = { __typename?: 'Mutation', createSignedUrlForUpload: { __typename?: 'TypeSignedUrlForUploadResults', data: { __typename?: 'TypeSignedUrlForUploadResultsData', uuid: string, upload_url: string } | null } };

export type HooksGetUploadsGraphQlQueryVariables = Exact<{
  upload_find_params: InputUploadFindParams;
}>;


export type HooksGetUploadsGraphQlQuery = { __typename?: 'Query', uploads: { __typename?: 'TypeUploadResults', data: { __typename?: 'TypeUploadResultsData', items: Array<{ __typename?: 'TypeUpload', uuid: TypeUUID, name: string, description: string, image: { __typename?: 'TypeUploadImage', uuid: TypeUUID, path: string } | null, video: { __typename?: 'TypeUploadVideo', uuid: TypeUUID, thumbnail_path: string } | null }> } | null } };

export type HooksUserSendConfirmEmailLinkGetQueryVariables = Exact<{
  uuid: Scalars['TypeUUID']['input'];
}>;


export type HooksUserSendConfirmEmailLinkGetQuery = { __typename?: 'Query', users: { __typename?: 'TypeUserResults', data: { __typename?: 'TypeUserResultsData', items: Array<{ __typename?: 'TypeUser', uuid: TypeUUID, email_is_confirmed: boolean }> } | null } };

export type HooksUserSendConfirmEmailLinkMutationVariables = Exact<{
  uuid: Scalars['TypeUUID']['input'];
}>;


export type HooksUserSendConfirmEmailLinkMutation = { __typename?: 'Mutation', sendConfirmEmailLink: { __typename?: 'TypeSendConfirmEmailLinkResults', data: { __typename?: 'TypeSendConfirmEmailLinkResultsData', user: { __typename?: 'TypeUser', uuid: TypeUUID } } | null } };

export const FragmentPageEntryPersonFragmentDoc = gql`
    fragment fragmentPageEntryPerson on TypePerson {
  uuid
  name
  summary
  biography
  path
  image_on_view {
    uuid
    path
  }
  fallback_image_path
}
    `;
export const FragmentAppHelmetFragmentDoc = gql`
    fragment fragmentAppHelmet on TypeAppHelmet {
  title
  description
  canonical_url
  jsonld
  image {
    url
    thumbnail_url
    dimensions {
      width
      height
    }
  }
  video_mp4 {
    url
  }
  disable_google_index
  published_time {
    iso
  }
  modified_time {
    iso
  }
}
    `;
export const FragmentGetUploadsUploadFragmentDoc = gql`
    fragment FragmentGetUploadsUpload on TypeUpload {
  uuid
  name
  description
  image {
    uuid
    path
  }
  video {
    uuid
    thumbnail_path
  }
}
    `;
export const FragmentPageDataViewerFragmentDoc = gql`
    fragment fragmentPageDataViewer on TypeUser {
  uuid
  name
  user_name
  email
  email_is_confirmed
  phone_number
  permission_roles
  is_banned
  is_approved
  credits
  coins
  created_at {
    iso
  }
  sc_user_context {
    user_uuid
    connection {
      id
    }
    get_started_completed
    is_subscribed
  }
}
    `;
export const FragmentPageDataProfileFragmentDoc = gql`
    fragment fragmentPageDataProfile on TypeProfile {
  uuid
  user_uuid
  name
  is_default
  autoplay_next_episode
  autoplay_preview
  avatar_direct {
    uuid
    path
  }
  fallback_avatar_path
}
    `;
export const FragmentPageDataCountryFragmentDoc = gql`
    fragment fragmentPageDataCountry on TypeCountry {
  code
  dial_code
  name
  is_united_states
  is_tanzania
}
    `;
export const FragmentPageDataCurrencyFragmentDoc = gql`
    fragment fragmentPageDataCurrency on TypeCurrencyResultsData {
  usd_tzs
}
    `;
export const HooksApplyCreditVoucherDocument = gql`
    mutation hooksApplyCreditVoucher($code: String!) {
  applyCreditVoucher(body: {code: $code}) {
    data {
      status
    }
  }
}
    `;
export type HooksApplyCreditVoucherMutationFn = Apollo.MutationFunction<HooksApplyCreditVoucherMutation, HooksApplyCreditVoucherMutationVariables>;

/**
 * __useHooksApplyCreditVoucherMutation__
 *
 * To run a mutation, you first call `useHooksApplyCreditVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksApplyCreditVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksApplyCreditVoucherMutation, { data, loading, error }] = useHooksApplyCreditVoucherMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useHooksApplyCreditVoucherMutation(baseOptions?: Apollo.MutationHookOptions<HooksApplyCreditVoucherMutation, HooksApplyCreditVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksApplyCreditVoucherMutation, HooksApplyCreditVoucherMutationVariables>(HooksApplyCreditVoucherDocument, options);
      }
export type HooksApplyCreditVoucherMutationHookResult = ReturnType<typeof useHooksApplyCreditVoucherMutation>;
export type HooksApplyCreditVoucherMutationResult = Apollo.MutationResult<HooksApplyCreditVoucherMutation>;
export type HooksApplyCreditVoucherMutationOptions = Apollo.BaseMutationOptions<HooksApplyCreditVoucherMutation, HooksApplyCreditVoucherMutationVariables>;
export const HooksConfirmEmailDocument = gql`
    mutation hooksConfirmEmail($token: String!) {
  accountConfirmEmail(body: {token: $token}) {
    data {
      status
    }
  }
}
    `;
export type HooksConfirmEmailMutationFn = Apollo.MutationFunction<HooksConfirmEmailMutation, HooksConfirmEmailMutationVariables>;

/**
 * __useHooksConfirmEmailMutation__
 *
 * To run a mutation, you first call `useHooksConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksConfirmEmailMutation, { data, loading, error }] = useHooksConfirmEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useHooksConfirmEmailMutation(baseOptions?: Apollo.MutationHookOptions<HooksConfirmEmailMutation, HooksConfirmEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksConfirmEmailMutation, HooksConfirmEmailMutationVariables>(HooksConfirmEmailDocument, options);
      }
export type HooksConfirmEmailMutationHookResult = ReturnType<typeof useHooksConfirmEmailMutation>;
export type HooksConfirmEmailMutationResult = Apollo.MutationResult<HooksConfirmEmailMutation>;
export type HooksConfirmEmailMutationOptions = Apollo.BaseMutationOptions<HooksConfirmEmailMutation, HooksConfirmEmailMutationVariables>;
export const HooksAccountCreateDocument = gql`
    mutation hooksAccountCreate($email: String!, $password: String!, $confirm_password: String!) {
  accountCreate(
    body: {email: $email, password: $password, confirm_password: $confirm_password}
  ) {
    data {
      uuid
      token
    }
  }
}
    `;
export type HooksAccountCreateMutationFn = Apollo.MutationFunction<HooksAccountCreateMutation, HooksAccountCreateMutationVariables>;

/**
 * __useHooksAccountCreateMutation__
 *
 * To run a mutation, you first call `useHooksAccountCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksAccountCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksAccountCreateMutation, { data, loading, error }] = useHooksAccountCreateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      confirm_password: // value for 'confirm_password'
 *   },
 * });
 */
export function useHooksAccountCreateMutation(baseOptions?: Apollo.MutationHookOptions<HooksAccountCreateMutation, HooksAccountCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksAccountCreateMutation, HooksAccountCreateMutationVariables>(HooksAccountCreateDocument, options);
      }
export type HooksAccountCreateMutationHookResult = ReturnType<typeof useHooksAccountCreateMutation>;
export type HooksAccountCreateMutationResult = Apollo.MutationResult<HooksAccountCreateMutation>;
export type HooksAccountCreateMutationOptions = Apollo.BaseMutationOptions<HooksAccountCreateMutation, HooksAccountCreateMutationVariables>;
export const HooksAccountForgotPasswordDocument = gql`
    mutation hooksAccountForgotPassword($email: String!) {
  sendPasswordResetLink(body: {email: $email}) {
    data {
      status
    }
  }
}
    `;
export type HooksAccountForgotPasswordMutationFn = Apollo.MutationFunction<HooksAccountForgotPasswordMutation, HooksAccountForgotPasswordMutationVariables>;

/**
 * __useHooksAccountForgotPasswordMutation__
 *
 * To run a mutation, you first call `useHooksAccountForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksAccountForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksAccountForgotPasswordMutation, { data, loading, error }] = useHooksAccountForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useHooksAccountForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<HooksAccountForgotPasswordMutation, HooksAccountForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksAccountForgotPasswordMutation, HooksAccountForgotPasswordMutationVariables>(HooksAccountForgotPasswordDocument, options);
      }
export type HooksAccountForgotPasswordMutationHookResult = ReturnType<typeof useHooksAccountForgotPasswordMutation>;
export type HooksAccountForgotPasswordMutationResult = Apollo.MutationResult<HooksAccountForgotPasswordMutation>;
export type HooksAccountForgotPasswordMutationOptions = Apollo.BaseMutationOptions<HooksAccountForgotPasswordMutation, HooksAccountForgotPasswordMutationVariables>;
export const HooksAccountLoginAppleDocument = gql`
    mutation hooksAccountLoginApple($body: InputAccountLoginAppleBody!) {
  accountLoginApple(body: $body) {
    data {
      uuid
      token
    }
  }
}
    `;
export type HooksAccountLoginAppleMutationFn = Apollo.MutationFunction<HooksAccountLoginAppleMutation, HooksAccountLoginAppleMutationVariables>;

/**
 * __useHooksAccountLoginAppleMutation__
 *
 * To run a mutation, you first call `useHooksAccountLoginAppleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksAccountLoginAppleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksAccountLoginAppleMutation, { data, loading, error }] = useHooksAccountLoginAppleMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useHooksAccountLoginAppleMutation(baseOptions?: Apollo.MutationHookOptions<HooksAccountLoginAppleMutation, HooksAccountLoginAppleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksAccountLoginAppleMutation, HooksAccountLoginAppleMutationVariables>(HooksAccountLoginAppleDocument, options);
      }
export type HooksAccountLoginAppleMutationHookResult = ReturnType<typeof useHooksAccountLoginAppleMutation>;
export type HooksAccountLoginAppleMutationResult = Apollo.MutationResult<HooksAccountLoginAppleMutation>;
export type HooksAccountLoginAppleMutationOptions = Apollo.BaseMutationOptions<HooksAccountLoginAppleMutation, HooksAccountLoginAppleMutationVariables>;
export const HooksLoginAuthCodeDocument = gql`
    mutation hooksLoginAuthCode($code: String!) {
  loginAuthCode(body: {code: $code}) {
    data {
      status
    }
  }
}
    `;
export type HooksLoginAuthCodeMutationFn = Apollo.MutationFunction<HooksLoginAuthCodeMutation, HooksLoginAuthCodeMutationVariables>;

/**
 * __useHooksLoginAuthCodeMutation__
 *
 * To run a mutation, you first call `useHooksLoginAuthCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksLoginAuthCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksLoginAuthCodeMutation, { data, loading, error }] = useHooksLoginAuthCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useHooksLoginAuthCodeMutation(baseOptions?: Apollo.MutationHookOptions<HooksLoginAuthCodeMutation, HooksLoginAuthCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksLoginAuthCodeMutation, HooksLoginAuthCodeMutationVariables>(HooksLoginAuthCodeDocument, options);
      }
export type HooksLoginAuthCodeMutationHookResult = ReturnType<typeof useHooksLoginAuthCodeMutation>;
export type HooksLoginAuthCodeMutationResult = Apollo.MutationResult<HooksLoginAuthCodeMutation>;
export type HooksLoginAuthCodeMutationOptions = Apollo.BaseMutationOptions<HooksLoginAuthCodeMutation, HooksLoginAuthCodeMutationVariables>;
export const HooksAccountLoginCodeDocument = gql`
    mutation hooksAccountLoginCode($body: InputAccountLoginCodeBody!) {
  accountLoginCode(body: $body) {
    data {
      uuid
      token
    }
  }
}
    `;
export type HooksAccountLoginCodeMutationFn = Apollo.MutationFunction<HooksAccountLoginCodeMutation, HooksAccountLoginCodeMutationVariables>;

/**
 * __useHooksAccountLoginCodeMutation__
 *
 * To run a mutation, you first call `useHooksAccountLoginCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksAccountLoginCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksAccountLoginCodeMutation, { data, loading, error }] = useHooksAccountLoginCodeMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useHooksAccountLoginCodeMutation(baseOptions?: Apollo.MutationHookOptions<HooksAccountLoginCodeMutation, HooksAccountLoginCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksAccountLoginCodeMutation, HooksAccountLoginCodeMutationVariables>(HooksAccountLoginCodeDocument, options);
      }
export type HooksAccountLoginCodeMutationHookResult = ReturnType<typeof useHooksAccountLoginCodeMutation>;
export type HooksAccountLoginCodeMutationResult = Apollo.MutationResult<HooksAccountLoginCodeMutation>;
export type HooksAccountLoginCodeMutationOptions = Apollo.BaseMutationOptions<HooksAccountLoginCodeMutation, HooksAccountLoginCodeMutationVariables>;
export const HooksAccountLoginFacebookDocument = gql`
    mutation hooksAccountLoginFacebook($body: InputAccountLoginFacebookBody!) {
  accountLoginFacebook(body: $body) {
    data {
      uuid
      token
    }
  }
}
    `;
export type HooksAccountLoginFacebookMutationFn = Apollo.MutationFunction<HooksAccountLoginFacebookMutation, HooksAccountLoginFacebookMutationVariables>;

/**
 * __useHooksAccountLoginFacebookMutation__
 *
 * To run a mutation, you first call `useHooksAccountLoginFacebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksAccountLoginFacebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksAccountLoginFacebookMutation, { data, loading, error }] = useHooksAccountLoginFacebookMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useHooksAccountLoginFacebookMutation(baseOptions?: Apollo.MutationHookOptions<HooksAccountLoginFacebookMutation, HooksAccountLoginFacebookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksAccountLoginFacebookMutation, HooksAccountLoginFacebookMutationVariables>(HooksAccountLoginFacebookDocument, options);
      }
export type HooksAccountLoginFacebookMutationHookResult = ReturnType<typeof useHooksAccountLoginFacebookMutation>;
export type HooksAccountLoginFacebookMutationResult = Apollo.MutationResult<HooksAccountLoginFacebookMutation>;
export type HooksAccountLoginFacebookMutationOptions = Apollo.BaseMutationOptions<HooksAccountLoginFacebookMutation, HooksAccountLoginFacebookMutationVariables>;
export const HooksAccountLoginGoogleDocument = gql`
    mutation hooksAccountLoginGoogle($body: InputAccountLoginGoogleBody!) {
  accountLoginGoogle(body: $body) {
    data {
      uuid
      token
    }
  }
}
    `;
export type HooksAccountLoginGoogleMutationFn = Apollo.MutationFunction<HooksAccountLoginGoogleMutation, HooksAccountLoginGoogleMutationVariables>;

/**
 * __useHooksAccountLoginGoogleMutation__
 *
 * To run a mutation, you first call `useHooksAccountLoginGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksAccountLoginGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksAccountLoginGoogleMutation, { data, loading, error }] = useHooksAccountLoginGoogleMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useHooksAccountLoginGoogleMutation(baseOptions?: Apollo.MutationHookOptions<HooksAccountLoginGoogleMutation, HooksAccountLoginGoogleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksAccountLoginGoogleMutation, HooksAccountLoginGoogleMutationVariables>(HooksAccountLoginGoogleDocument, options);
      }
export type HooksAccountLoginGoogleMutationHookResult = ReturnType<typeof useHooksAccountLoginGoogleMutation>;
export type HooksAccountLoginGoogleMutationResult = Apollo.MutationResult<HooksAccountLoginGoogleMutation>;
export type HooksAccountLoginGoogleMutationOptions = Apollo.BaseMutationOptions<HooksAccountLoginGoogleMutation, HooksAccountLoginGoogleMutationVariables>;
export const HooksAccountLoginDocument = gql`
    mutation hooksAccountLogin($user_name: String!, $password: String!) {
  accountLogin(body: {user_name: $user_name, password: $password}) {
    data {
      uuid
      token
    }
  }
}
    `;
export type HooksAccountLoginMutationFn = Apollo.MutationFunction<HooksAccountLoginMutation, HooksAccountLoginMutationVariables>;

/**
 * __useHooksAccountLoginMutation__
 *
 * To run a mutation, you first call `useHooksAccountLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksAccountLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksAccountLoginMutation, { data, loading, error }] = useHooksAccountLoginMutation({
 *   variables: {
 *      user_name: // value for 'user_name'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useHooksAccountLoginMutation(baseOptions?: Apollo.MutationHookOptions<HooksAccountLoginMutation, HooksAccountLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksAccountLoginMutation, HooksAccountLoginMutationVariables>(HooksAccountLoginDocument, options);
      }
export type HooksAccountLoginMutationHookResult = ReturnType<typeof useHooksAccountLoginMutation>;
export type HooksAccountLoginMutationResult = Apollo.MutationResult<HooksAccountLoginMutation>;
export type HooksAccountLoginMutationOptions = Apollo.BaseMutationOptions<HooksAccountLoginMutation, HooksAccountLoginMutationVariables>;
export const HooksAccountLogoutDocument = gql`
    mutation hooksAccountLogout {
  accountLogout {
    data {
      status
    }
  }
}
    `;
export type HooksAccountLogoutMutationFn = Apollo.MutationFunction<HooksAccountLogoutMutation, HooksAccountLogoutMutationVariables>;

/**
 * __useHooksAccountLogoutMutation__
 *
 * To run a mutation, you first call `useHooksAccountLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksAccountLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksAccountLogoutMutation, { data, loading, error }] = useHooksAccountLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useHooksAccountLogoutMutation(baseOptions?: Apollo.MutationHookOptions<HooksAccountLogoutMutation, HooksAccountLogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksAccountLogoutMutation, HooksAccountLogoutMutationVariables>(HooksAccountLogoutDocument, options);
      }
export type HooksAccountLogoutMutationHookResult = ReturnType<typeof useHooksAccountLogoutMutation>;
export type HooksAccountLogoutMutationResult = Apollo.MutationResult<HooksAccountLogoutMutation>;
export type HooksAccountLogoutMutationOptions = Apollo.BaseMutationOptions<HooksAccountLogoutMutation, HooksAccountLogoutMutationVariables>;
export const HooksAccountResetPasswordDocument = gql`
    mutation hooksAccountResetPassword($token: String!, $password: String!, $confirm_password: String!) {
  accountResetPassword(
    body: {token: $token, password: $password, confirm_password: $confirm_password}
  ) {
    data {
      uuid
      token
    }
  }
}
    `;
export type HooksAccountResetPasswordMutationFn = Apollo.MutationFunction<HooksAccountResetPasswordMutation, HooksAccountResetPasswordMutationVariables>;

/**
 * __useHooksAccountResetPasswordMutation__
 *
 * To run a mutation, you first call `useHooksAccountResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksAccountResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksAccountResetPasswordMutation, { data, loading, error }] = useHooksAccountResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *      confirm_password: // value for 'confirm_password'
 *   },
 * });
 */
export function useHooksAccountResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<HooksAccountResetPasswordMutation, HooksAccountResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksAccountResetPasswordMutation, HooksAccountResetPasswordMutationVariables>(HooksAccountResetPasswordDocument, options);
      }
export type HooksAccountResetPasswordMutationHookResult = ReturnType<typeof useHooksAccountResetPasswordMutation>;
export type HooksAccountResetPasswordMutationResult = Apollo.MutationResult<HooksAccountResetPasswordMutation>;
export type HooksAccountResetPasswordMutationOptions = Apollo.BaseMutationOptions<HooksAccountResetPasswordMutation, HooksAccountResetPasswordMutationVariables>;
export const HooksSendLoginCodeDocument = gql`
    mutation hooksSendLoginCode($body: InputSendLoginCodeBody!) {
  sendLoginCode(body: $body) {
    message
  }
}
    `;
export type HooksSendLoginCodeMutationFn = Apollo.MutationFunction<HooksSendLoginCodeMutation, HooksSendLoginCodeMutationVariables>;

/**
 * __useHooksSendLoginCodeMutation__
 *
 * To run a mutation, you first call `useHooksSendLoginCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksSendLoginCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksSendLoginCodeMutation, { data, loading, error }] = useHooksSendLoginCodeMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useHooksSendLoginCodeMutation(baseOptions?: Apollo.MutationHookOptions<HooksSendLoginCodeMutation, HooksSendLoginCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksSendLoginCodeMutation, HooksSendLoginCodeMutationVariables>(HooksSendLoginCodeDocument, options);
      }
export type HooksSendLoginCodeMutationHookResult = ReturnType<typeof useHooksSendLoginCodeMutation>;
export type HooksSendLoginCodeMutationResult = Apollo.MutationResult<HooksSendLoginCodeMutation>;
export type HooksSendLoginCodeMutationOptions = Apollo.BaseMutationOptions<HooksSendLoginCodeMutation, HooksSendLoginCodeMutationVariables>;
export const PageEntryPersonDocument = gql`
    query PageEntryPerson($user_name: String!) {
  pageEntry {
    data {
      pageEntryPerson(body: {user_name: $user_name}) {
        uuid
        person {
          ...fragmentPageEntryPerson
        }
        show {
          uuid
          movie {
            uuid
            title
            path
            cover_on_view {
              uuid
              path
            }
            fallback_cover_path
          }
          tv {
            uuid
            title
            path
            cover_on_view {
              uuid
              path
            }
            fallback_cover_path
          }
        }
        crossword {
          uuid
          title
          number
          path
          image_on_view {
            uuid
            path
          }
          fallback_image_path
        }
        helmet {
          ...fragmentAppHelmet
        }
      }
    }
  }
}
    ${FragmentPageEntryPersonFragmentDoc}
${FragmentAppHelmetFragmentDoc}`;

/**
 * __usePageEntryPersonQuery__
 *
 * To run a query within a React component, call `usePageEntryPersonQuery` and pass it any options that fit your needs.
 * When your component renders, `usePageEntryPersonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePageEntryPersonQuery({
 *   variables: {
 *      user_name: // value for 'user_name'
 *   },
 * });
 */
export function usePageEntryPersonQuery(baseOptions: Apollo.QueryHookOptions<PageEntryPersonQuery, PageEntryPersonQueryVariables> & ({ variables: PageEntryPersonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PageEntryPersonQuery, PageEntryPersonQueryVariables>(PageEntryPersonDocument, options);
      }
export function usePageEntryPersonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PageEntryPersonQuery, PageEntryPersonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PageEntryPersonQuery, PageEntryPersonQueryVariables>(PageEntryPersonDocument, options);
        }
export function usePageEntryPersonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PageEntryPersonQuery, PageEntryPersonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PageEntryPersonQuery, PageEntryPersonQueryVariables>(PageEntryPersonDocument, options);
        }
export type PageEntryPersonQueryHookResult = ReturnType<typeof usePageEntryPersonQuery>;
export type PageEntryPersonLazyQueryHookResult = ReturnType<typeof usePageEntryPersonLazyQuery>;
export type PageEntryPersonSuspenseQueryHookResult = ReturnType<typeof usePageEntryPersonSuspenseQuery>;
export type PageEntryPersonQueryResult = Apollo.QueryResult<PageEntryPersonQuery, PageEntryPersonQueryVariables>;
export const GetUploadsDocument = gql`
    query getUploads($uuids: [TypeUUID!]!) {
  uploadsByUUID(uuids: $uuids) {
    ...FragmentGetUploadsUpload
  }
}
    ${FragmentGetUploadsUploadFragmentDoc}`;

/**
 * __useGetUploadsQuery__
 *
 * To run a query within a React component, call `useGetUploadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUploadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUploadsQuery({
 *   variables: {
 *      uuids: // value for 'uuids'
 *   },
 * });
 */
export function useGetUploadsQuery(baseOptions: Apollo.QueryHookOptions<GetUploadsQuery, GetUploadsQueryVariables> & ({ variables: GetUploadsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUploadsQuery, GetUploadsQueryVariables>(GetUploadsDocument, options);
      }
export function useGetUploadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUploadsQuery, GetUploadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUploadsQuery, GetUploadsQueryVariables>(GetUploadsDocument, options);
        }
export function useGetUploadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUploadsQuery, GetUploadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUploadsQuery, GetUploadsQueryVariables>(GetUploadsDocument, options);
        }
export type GetUploadsQueryHookResult = ReturnType<typeof useGetUploadsQuery>;
export type GetUploadsLazyQueryHookResult = ReturnType<typeof useGetUploadsLazyQuery>;
export type GetUploadsSuspenseQueryHookResult = ReturnType<typeof useGetUploadsSuspenseQuery>;
export type GetUploadsQueryResult = Apollo.QueryResult<GetUploadsQuery, GetUploadsQueryVariables>;
export const HooksPageDataDocument = gql`
    query hooksPageData {
  viewer {
    ...fragmentPageDataViewer
  }
  viewerProfile {
    ...fragmentPageDataProfile
  }
  viewerProfiles {
    ...fragmentPageDataProfile
  }
}
    ${FragmentPageDataViewerFragmentDoc}
${FragmentPageDataProfileFragmentDoc}`;

/**
 * __useHooksPageDataQuery__
 *
 * To run a query within a React component, call `useHooksPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useHooksPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHooksPageDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useHooksPageDataQuery(baseOptions?: Apollo.QueryHookOptions<HooksPageDataQuery, HooksPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HooksPageDataQuery, HooksPageDataQueryVariables>(HooksPageDataDocument, options);
      }
export function useHooksPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HooksPageDataQuery, HooksPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HooksPageDataQuery, HooksPageDataQueryVariables>(HooksPageDataDocument, options);
        }
export function useHooksPageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HooksPageDataQuery, HooksPageDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HooksPageDataQuery, HooksPageDataQueryVariables>(HooksPageDataDocument, options);
        }
export type HooksPageDataQueryHookResult = ReturnType<typeof useHooksPageDataQuery>;
export type HooksPageDataLazyQueryHookResult = ReturnType<typeof useHooksPageDataLazyQuery>;
export type HooksPageDataSuspenseQueryHookResult = ReturnType<typeof useHooksPageDataSuspenseQuery>;
export type HooksPageDataQueryResult = Apollo.QueryResult<HooksPageDataQuery, HooksPageDataQueryVariables>;
export const HooksPageDataCountryDocument = gql`
    query hooksPageDataCountry {
  country {
    ...fragmentPageDataCountry
  }
}
    ${FragmentPageDataCountryFragmentDoc}`;

/**
 * __useHooksPageDataCountryQuery__
 *
 * To run a query within a React component, call `useHooksPageDataCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHooksPageDataCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHooksPageDataCountryQuery({
 *   variables: {
 *   },
 * });
 */
export function useHooksPageDataCountryQuery(baseOptions?: Apollo.QueryHookOptions<HooksPageDataCountryQuery, HooksPageDataCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HooksPageDataCountryQuery, HooksPageDataCountryQueryVariables>(HooksPageDataCountryDocument, options);
      }
export function useHooksPageDataCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HooksPageDataCountryQuery, HooksPageDataCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HooksPageDataCountryQuery, HooksPageDataCountryQueryVariables>(HooksPageDataCountryDocument, options);
        }
export function useHooksPageDataCountrySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HooksPageDataCountryQuery, HooksPageDataCountryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HooksPageDataCountryQuery, HooksPageDataCountryQueryVariables>(HooksPageDataCountryDocument, options);
        }
export type HooksPageDataCountryQueryHookResult = ReturnType<typeof useHooksPageDataCountryQuery>;
export type HooksPageDataCountryLazyQueryHookResult = ReturnType<typeof useHooksPageDataCountryLazyQuery>;
export type HooksPageDataCountrySuspenseQueryHookResult = ReturnType<typeof useHooksPageDataCountrySuspenseQuery>;
export type HooksPageDataCountryQueryResult = Apollo.QueryResult<HooksPageDataCountryQuery, HooksPageDataCountryQueryVariables>;
export const HooksPageDataCurrencyDocument = gql`
    query hooksPageDataCurrency {
  currency {
    data {
      ...fragmentPageDataCurrency
    }
  }
}
    ${FragmentPageDataCurrencyFragmentDoc}`;

/**
 * __useHooksPageDataCurrencyQuery__
 *
 * To run a query within a React component, call `useHooksPageDataCurrencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useHooksPageDataCurrencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHooksPageDataCurrencyQuery({
 *   variables: {
 *   },
 * });
 */
export function useHooksPageDataCurrencyQuery(baseOptions?: Apollo.QueryHookOptions<HooksPageDataCurrencyQuery, HooksPageDataCurrencyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HooksPageDataCurrencyQuery, HooksPageDataCurrencyQueryVariables>(HooksPageDataCurrencyDocument, options);
      }
export function useHooksPageDataCurrencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HooksPageDataCurrencyQuery, HooksPageDataCurrencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HooksPageDataCurrencyQuery, HooksPageDataCurrencyQueryVariables>(HooksPageDataCurrencyDocument, options);
        }
export function useHooksPageDataCurrencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HooksPageDataCurrencyQuery, HooksPageDataCurrencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HooksPageDataCurrencyQuery, HooksPageDataCurrencyQueryVariables>(HooksPageDataCurrencyDocument, options);
        }
export type HooksPageDataCurrencyQueryHookResult = ReturnType<typeof useHooksPageDataCurrencyQuery>;
export type HooksPageDataCurrencyLazyQueryHookResult = ReturnType<typeof useHooksPageDataCurrencyLazyQuery>;
export type HooksPageDataCurrencySuspenseQueryHookResult = ReturnType<typeof useHooksPageDataCurrencySuspenseQuery>;
export type HooksPageDataCurrencyQueryResult = Apollo.QueryResult<HooksPageDataCurrencyQuery, HooksPageDataCurrencyQueryVariables>;
export const HooksCreateSignedUrlForUploadDocument = gql`
    mutation hooksCreateSignedUrlForUpload($body: InputSignedUrlForUpload!) {
  createSignedUrlForUpload(body: $body) {
    data {
      uuid
      upload_url
    }
  }
}
    `;
export type HooksCreateSignedUrlForUploadMutationFn = Apollo.MutationFunction<HooksCreateSignedUrlForUploadMutation, HooksCreateSignedUrlForUploadMutationVariables>;

/**
 * __useHooksCreateSignedUrlForUploadMutation__
 *
 * To run a mutation, you first call `useHooksCreateSignedUrlForUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksCreateSignedUrlForUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksCreateSignedUrlForUploadMutation, { data, loading, error }] = useHooksCreateSignedUrlForUploadMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useHooksCreateSignedUrlForUploadMutation(baseOptions?: Apollo.MutationHookOptions<HooksCreateSignedUrlForUploadMutation, HooksCreateSignedUrlForUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksCreateSignedUrlForUploadMutation, HooksCreateSignedUrlForUploadMutationVariables>(HooksCreateSignedUrlForUploadDocument, options);
      }
export type HooksCreateSignedUrlForUploadMutationHookResult = ReturnType<typeof useHooksCreateSignedUrlForUploadMutation>;
export type HooksCreateSignedUrlForUploadMutationResult = Apollo.MutationResult<HooksCreateSignedUrlForUploadMutation>;
export type HooksCreateSignedUrlForUploadMutationOptions = Apollo.BaseMutationOptions<HooksCreateSignedUrlForUploadMutation, HooksCreateSignedUrlForUploadMutationVariables>;
export const HooksGetUploadsGraphQlDocument = gql`
    query hooksGetUploadsGraphQL($upload_find_params: InputUploadFindParams!) {
  uploads(body: {upload_find_params: $upload_find_params}) {
    data {
      items {
        uuid
        name
        description
        image {
          uuid
          path
        }
        video {
          uuid
          thumbnail_path
        }
      }
    }
  }
}
    `;

/**
 * __useHooksGetUploadsGraphQlQuery__
 *
 * To run a query within a React component, call `useHooksGetUploadsGraphQlQuery` and pass it any options that fit your needs.
 * When your component renders, `useHooksGetUploadsGraphQlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHooksGetUploadsGraphQlQuery({
 *   variables: {
 *      upload_find_params: // value for 'upload_find_params'
 *   },
 * });
 */
export function useHooksGetUploadsGraphQlQuery(baseOptions: Apollo.QueryHookOptions<HooksGetUploadsGraphQlQuery, HooksGetUploadsGraphQlQueryVariables> & ({ variables: HooksGetUploadsGraphQlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HooksGetUploadsGraphQlQuery, HooksGetUploadsGraphQlQueryVariables>(HooksGetUploadsGraphQlDocument, options);
      }
export function useHooksGetUploadsGraphQlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HooksGetUploadsGraphQlQuery, HooksGetUploadsGraphQlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HooksGetUploadsGraphQlQuery, HooksGetUploadsGraphQlQueryVariables>(HooksGetUploadsGraphQlDocument, options);
        }
export function useHooksGetUploadsGraphQlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HooksGetUploadsGraphQlQuery, HooksGetUploadsGraphQlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HooksGetUploadsGraphQlQuery, HooksGetUploadsGraphQlQueryVariables>(HooksGetUploadsGraphQlDocument, options);
        }
export type HooksGetUploadsGraphQlQueryHookResult = ReturnType<typeof useHooksGetUploadsGraphQlQuery>;
export type HooksGetUploadsGraphQlLazyQueryHookResult = ReturnType<typeof useHooksGetUploadsGraphQlLazyQuery>;
export type HooksGetUploadsGraphQlSuspenseQueryHookResult = ReturnType<typeof useHooksGetUploadsGraphQlSuspenseQuery>;
export type HooksGetUploadsGraphQlQueryResult = Apollo.QueryResult<HooksGetUploadsGraphQlQuery, HooksGetUploadsGraphQlQueryVariables>;
export const HooksUserSendConfirmEmailLinkGetDocument = gql`
    query hooksUserSendConfirmEmailLinkGet($uuid: TypeUUID!) {
  users(body: {user_find_params: {page: 1, quantity: 1, uuids: [$uuid]}}) {
    data {
      items {
        uuid
        email_is_confirmed
      }
    }
  }
}
    `;

/**
 * __useHooksUserSendConfirmEmailLinkGetQuery__
 *
 * To run a query within a React component, call `useHooksUserSendConfirmEmailLinkGetQuery` and pass it any options that fit your needs.
 * When your component renders, `useHooksUserSendConfirmEmailLinkGetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHooksUserSendConfirmEmailLinkGetQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useHooksUserSendConfirmEmailLinkGetQuery(baseOptions: Apollo.QueryHookOptions<HooksUserSendConfirmEmailLinkGetQuery, HooksUserSendConfirmEmailLinkGetQueryVariables> & ({ variables: HooksUserSendConfirmEmailLinkGetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HooksUserSendConfirmEmailLinkGetQuery, HooksUserSendConfirmEmailLinkGetQueryVariables>(HooksUserSendConfirmEmailLinkGetDocument, options);
      }
export function useHooksUserSendConfirmEmailLinkGetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HooksUserSendConfirmEmailLinkGetQuery, HooksUserSendConfirmEmailLinkGetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HooksUserSendConfirmEmailLinkGetQuery, HooksUserSendConfirmEmailLinkGetQueryVariables>(HooksUserSendConfirmEmailLinkGetDocument, options);
        }
export function useHooksUserSendConfirmEmailLinkGetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HooksUserSendConfirmEmailLinkGetQuery, HooksUserSendConfirmEmailLinkGetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HooksUserSendConfirmEmailLinkGetQuery, HooksUserSendConfirmEmailLinkGetQueryVariables>(HooksUserSendConfirmEmailLinkGetDocument, options);
        }
export type HooksUserSendConfirmEmailLinkGetQueryHookResult = ReturnType<typeof useHooksUserSendConfirmEmailLinkGetQuery>;
export type HooksUserSendConfirmEmailLinkGetLazyQueryHookResult = ReturnType<typeof useHooksUserSendConfirmEmailLinkGetLazyQuery>;
export type HooksUserSendConfirmEmailLinkGetSuspenseQueryHookResult = ReturnType<typeof useHooksUserSendConfirmEmailLinkGetSuspenseQuery>;
export type HooksUserSendConfirmEmailLinkGetQueryResult = Apollo.QueryResult<HooksUserSendConfirmEmailLinkGetQuery, HooksUserSendConfirmEmailLinkGetQueryVariables>;
export const HooksUserSendConfirmEmailLinkDocument = gql`
    mutation hooksUserSendConfirmEmailLink($uuid: TypeUUID!) {
  sendConfirmEmailLink(body: {uuid: $uuid}) {
    data {
      user {
        uuid
      }
    }
  }
}
    `;
export type HooksUserSendConfirmEmailLinkMutationFn = Apollo.MutationFunction<HooksUserSendConfirmEmailLinkMutation, HooksUserSendConfirmEmailLinkMutationVariables>;

/**
 * __useHooksUserSendConfirmEmailLinkMutation__
 *
 * To run a mutation, you first call `useHooksUserSendConfirmEmailLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHooksUserSendConfirmEmailLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hooksUserSendConfirmEmailLinkMutation, { data, loading, error }] = useHooksUserSendConfirmEmailLinkMutation({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useHooksUserSendConfirmEmailLinkMutation(baseOptions?: Apollo.MutationHookOptions<HooksUserSendConfirmEmailLinkMutation, HooksUserSendConfirmEmailLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HooksUserSendConfirmEmailLinkMutation, HooksUserSendConfirmEmailLinkMutationVariables>(HooksUserSendConfirmEmailLinkDocument, options);
      }
export type HooksUserSendConfirmEmailLinkMutationHookResult = ReturnType<typeof useHooksUserSendConfirmEmailLinkMutation>;
export type HooksUserSendConfirmEmailLinkMutationResult = Apollo.MutationResult<HooksUserSendConfirmEmailLinkMutation>;
export type HooksUserSendConfirmEmailLinkMutationOptions = Apollo.BaseMutationOptions<HooksUserSendConfirmEmailLinkMutation, HooksUserSendConfirmEmailLinkMutationVariables>;